function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEarlyNight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.11,325.06,86,325.33l-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0L99,319.4c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.34,339.17l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.44l0-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27V328c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.42.05-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.19-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.74,292.6l-13.13.28L555,293c-2.22,0-4.46,0-6.69.05h-.45v-.45l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.11,13.24.16H575v.26c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.86-.11-3.7-.13-5.54l.28.28c-4.42.05-8.83.16-13.24.16l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560,306.71l-13.13.28-6.66.12c-2.23,0-4.46,0-6.7.05H533v-.45l0-11.19V295h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5-.05,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.89,200.84l-13.12.27-6.66.12c-2.23,0-4.46,0-6.7.05H391v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.12,215l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7,0h-.44V215l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5L377.09,215l-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,200.84l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.14,339.17l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44L665.16,328v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V328c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.74,133.78l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.12,13.24.17H575v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.37,65.49l-13.12.27-6.67.12c-2.22,0-4.46,0-6.69.05h-.44v-.45l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.14,79.6,679,79.87l-6.66.12c-2.23,0-4.47,0-6.7.05h-.44V79.6l-.06-11.19V67.9h.5L678.9,68c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0L692,73.94c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.79,133.78l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.06-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.44c2.18,0,4.36,0,6.55,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,147.89l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.14,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.34,65.49l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.45l0-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.42,0-8.83.16-13.24.16l-13.24.07.5-.5L58.3,65.49,57.86,65c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.15,45.31V254.8h149.9V45.31Zm145.44,205h-141V49.77h141Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.61,
    y: 49.77,
    width: 140.97,
    height: 200.57,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "649.52 169.81 650.61 172.03 653.05 172.38 651.28 174.1 651.7 176.53 649.52 175.38 647.33 176.53 647.75 174.1 645.98 172.38 648.42 172.03 649.52 169.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.6 164.48 583.69 166.7 586.13 167.05 584.36 168.77 584.78 171.2 582.6 170.05 580.42 171.2 580.83 168.77 579.07 167.05 581.51 166.7 582.6 164.48",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "553.27 218.92 554.36 221.13 556.8 221.48 555.03 223.2 555.45 225.63 553.27 224.49 551.08 225.63 551.5 223.2 549.74 221.48 552.17 221.13 553.27 218.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "649.52 107.65 650.19 109.02 651.7 109.23 650.61 110.3 650.87 111.8 649.52 111.09 648.17 111.8 648.42 110.3 647.33 109.23 648.84 109.02 649.52 107.65",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.34 157.7 546.01 159.06 547.52 159.28 546.43 160.35 546.68 161.85 545.34 161.14 543.99 161.85 544.25 160.35 543.15 159.28 544.66 159.06 545.34 157.7",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "632.88 216.84 633.56 218.21 635.07 218.43 633.98 219.49 634.23 220.99 632.88 220.28 631.54 220.99 631.79 219.49 630.7 218.43 632.21 218.21 632.88 216.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.31 116.29 588.99 117.65 590.5 117.87 589.4 118.94 589.66 120.44 588.31 119.73 586.96 120.44 587.22 118.94 586.13 117.87 587.64 117.65 588.31 116.29",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.91,135.47a16.24,16.24,0,1,1-17.69-23.9,15.19,15.19,0,1,0,17.69,23.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.87,
    y: 50.93,
    width: 4.45,
    height: 201.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.13,
    y: 54.31,
    width: 157.95,
    height: 6.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.13,
    y: 61.29,
    width: 157.95,
    height: 6.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.13,
    y: 68.26,
    width: 157.95,
    height: 6.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.13,
    y: 75.23,
    width: 157.95,
    height: 6.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.13,
    y: 82.2,
    width: 157.95,
    height: 6.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.13,
    y: 89.18,
    width: 157.95,
    height: 6.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.74,
    y: 53.06,
    width: 1.11,
    height: 120.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.28 178.85 661.33 178.85 662.32 173.17 664.29 173.17 665.28 178.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.75,
    y: 53.06,
    width: 1.11,
    height: 151.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.28 208.26 665.33 208.26 666.33 202.59 668.29 202.59 669.28 208.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.22,
    y: 44.45,
    width: 171.77,
    height: 12.97,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.46,
    y: 78.48,
    width: 58.33,
    height: 58.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,139.85V75.45h-64.4v64.4ZM218.46,78.48h58.33v58.33H218.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.31,
    y: 77.13,
    width: 20.16,
    height: 45.46,
    transform: "translate(145.53 345.25) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.98,
    y: 96,
    width: 23.29,
    height: 23.29,
    transform: "translate(139.98 355.27) rotate(-90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.94,
    y: 75.45,
    width: 2.49,
    height: 64.4,
    transform: "translate(428.36 215.3) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.56,
    y: 78.48,
    width: 58.33,
    height: 58.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.64,
    y: 83.48,
    width: 15.23,
    height: 44,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.93,139.85V75.45h-64.4v64.4ZM300.56,78.48h58.33v58.34H300.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.08,
    y: 96,
    width: 23.29,
    height: 23.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.04,
    y: 75.45,
    width: 2.49,
    height: 64.4,
    transform: "translate(592.57 215.3) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.68,
    y: 78.48,
    width: 58.33,
    height: 58.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.54,
    y: 109.73,
    width: 32.01,
    height: 19.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,139.85V75.45h-64.4v64.4ZM134.68,78.48H193v58.34H134.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.2,
    y: 96,
    width: 23.29,
    height: 23.29,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.16,
    y: 75.45,
    width: 2.49,
    height: 64.4,
    transform: "translate(260.8 215.3) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "58.41 447.98 137.56 447.73 216.71 447.64 375 447.48 533.29 447.64 612.44 447.73 691.59 447.98 612.44 448.22 533.29 448.31 375 448.48 216.71 448.31 137.56 448.22 58.41 447.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.12 447.98 473.87 396.31 473.78 344.65 473.62 241.32 473.78 137.99 473.87 86.33 474.12 34.66 474.36 86.33 474.45 137.99 474.61 241.32 474.45 344.65 474.36 396.31 474.12 447.98",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4,255.85c10.31,10.1,12,25.73,9.87,39.41-.06.31-.54.23-.54-.06,0-3.12.1-6.21.09-9.28-.06-.14-.11-.28-.16-.42a20.73,20.73,0,0,1-6.7-7.2c-1.73-3.39-2.4-7.21-3.72-10.75-.12-.34.24-.24.47-.06C88,272.12,90,277.1,91.79,283.75a56.08,56.08,0,0,0-1.09-10.36c-1.36-6.32-4-12.58-8.58-17.26A.2.2,0,0,1,82.4,255.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.46,257c-1.78.06-2.89,2.9-4.27,3.73a1.33,1.33,0,0,1-2-.31c-1.37-1.92.51-4.28,2.28-5.6-1.27.52-2.32,1.44-3.68,1.7a1.28,1.28,0,0,1-1.66-1c-.6-2.6,2.67-3.76,4.91-3.82-1.08-.76-4.2-2.81-2.55-3.82s5.34,1.92,6.54,2.89c1.75,1.42,3.84,3.55,3.92,5.78C84.1,259.18,81.82,257.58,80.46,257Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.46,257c-1.78.06-2.89,2.9-4.27,3.73a1.33,1.33,0,0,1-2-.31c-1.37-1.92.51-4.28,2.28-5.6-1.27.52-2.32,1.44-3.68,1.7a1.28,1.28,0,0,1-1.66-1c-.6-2.6,2.67-3.76,4.91-3.82-1.08-.76-4.2-2.81-2.55-3.82s5.34,1.92,6.54,2.89c1.75,1.42,3.84,3.55,3.92,5.78C84.1,259.18,81.82,257.58,80.46,257Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,257.47c-2.27-1-6.63.45-7-.41-.75-1.74,2.73-2.94,4.61-3.18-1.73-.47-5-1.21-4.94-2.88.12-2,5.09-.29,7.6,1.64,3.16,2.43,3.14,4.77,2.62,5.24C83.14,258.52,81.35,257.64,81,257.47Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.89,254.85c-10.69,9.7-13,25.25-11.37,39,0,.31.53.24.54-.05.12-3.11.15-6.2.27-9.27l.18-.41a20.84,20.84,0,0,0,7-6.94c1.85-3.32,2.67-7.11,4.12-10.6.14-.33-.23-.25-.47-.08-6.45,4.38-8.64,9.28-10.69,15.86a55.26,55.26,0,0,1,1.49-10.31c1.59-6.26,4.51-12.41,9.22-16.92C106.33,255,106.08,254.68,105.89,254.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.78,256.1c1.77.13,2.78,3,4.13,3.89a1.33,1.33,0,0,0,2-.23c1.44-1.86-.35-4.29-2.07-5.68,1.25.57,2.26,1.52,3.61,1.83a1.29,1.29,0,0,0,1.7-.93c.7-2.58-2.53-3.87-4.77-4,1.12-.71,4.31-2.65,2.7-3.72s-5.41,1.72-6.64,2.64c-1.81,1.36-4,3.4-4.14,5.63C104.07,258.11,106.4,256.6,107.78,256.1Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.78,256.1c1.77.13,2.78,3,4.13,3.89a1.33,1.33,0,0,0,2-.23c1.44-1.86-.35-4.29-2.07-5.68,1.25.57,2.26,1.52,3.61,1.83a1.29,1.29,0,0,0,1.7-.93c.7-2.58-2.53-3.87-4.77-4,1.12-.71,4.31-2.65,2.7-3.72s-5.41,1.72-6.64,2.64c-1.81,1.36-4,3.4-4.14,5.63C104.07,258.11,106.4,256.6,107.78,256.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.25,256.52c2.31-.94,6.61.71,7-.14.82-1.72-2.62-3-4.49-3.35,1.75-.4,5.1-1,5.06-2.7,0-2-5.08-.47-7.66,1.36-3.26,2.3-3.33,4.64-2.82,5.13C105,257.49,106.87,256.68,107.25,256.52Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,280.47a105.59,105.59,0,0,1-3.32,15.34.38.38,0,0,1-.75-.15c.7-4.73,2-9.37,2.68-14.09a70.12,70.12,0,0,0,.82-14.47c-.45-8-2.61-16.44-7.81-22.67-.11-.15.13-.35.25-.22,10.41,12.13,8.75,27,8.74,28.34,1.47-5,3-10.78,8.56-15.89.24-.22.43-.12.39.26-1,9.31-3.59,14.18-9,19.16C95.38,277.55,95.19,279,95,280.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.49,245.83c-1.87-.83-4.45,1.55-6.3,1.71a1.53,1.53,0,0,1-1.88-1.3c-.46-2.68,2.68-4.18,5.18-4.66-1.58-.1-3.12.32-4.67-.09a1.48,1.48,0,0,1-1.22-1.87c.69-3,4.67-2.57,7-1.49-.75-1.34-3-5-.72-5.25s4.57,4.68,5.32,6.28c1.11,2.36,2.21,5.62,1.17,8C89.19,249.88,87.63,247.08,86.49,245.83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.49,245.83c-1.87-.83-4.45,1.55-6.3,1.71a1.53,1.53,0,0,1-1.88-1.3c-.46-2.68,2.68-4.18,5.18-4.66-1.58-.1-3.12.32-4.67-.09a1.48,1.48,0,0,1-1.22-1.87c.69-3,4.67-2.57,7-1.49-.75-1.34-3-5-.72-5.25s4.57,4.68,5.32,6.28c1.11,2.36,2.21,5.62,1.17,8C89.19,249.88,87.63,247.08,86.49,245.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8,246.54c-1.83-2.21-7.1-2.87-7-3.94.1-2.2,4.31-1.69,6.38-1-1.56-1.36-4.62-3.81-3.68-5.49,1.16-2,5.43,2.27,7.06,5.53,2.06,4.11.86,6.53.09,6.76C88.53,248.72,87.11,246.9,86.8,246.54Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,283.27l4.59,35.06H78.47c.57-3.1,5.77-35.1,5.77-35.1Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.96,
    y: 184.64,
    width: 251.18,
    height: 225.24,
    transform: "translate(503.1 594.52) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.96,
    y: 184.64,
    width: 251.18,
    height: 225.24,
    transform: "translate(503.1 594.52) rotate(180)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.62,
    y: 184.64,
    width: 9.34,
    height: 263.34,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.62,
    y: 184.64,
    width: 9.34,
    height: 263.34,
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.52,
    y: 409.88,
    width: 9.34,
    height: 38.09,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.52,
    y: 409.88,
    width: 9.34,
    height: 38.09,
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.86,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(723 857.86) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.86,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(723 857.86) rotate(180)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.96,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(283.2 857.86) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.96,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(283.2 857.86) rotate(180)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.96,
    y: 375.92,
    width: 314.45,
    height: 33.96,
    transform: "translate(566.37 785.81) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.96,
    y: 375.92,
    width: 314.45,
    height: 33.96,
    transform: "translate(566.37 785.81) rotate(180)",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.41,
    y: 375.92,
    width: 251.18,
    height: 33.96,
    transform: "translate(1132 785.81) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.41,
    y: 375.92,
    width: 251.18,
    height: 33.96,
    transform: "translate(1132 785.81) rotate(180)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.07,
    y: 409.88,
    width: 9.34,
    height: 38.09,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.07,
    y: 409.88,
    width: 9.34,
    height: 38.09,
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.97,
    y: 409.88,
    width: 9.34,
    height: 38.09,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.97,
    y: 409.88,
    width: 9.34,
    height: 38.09,
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.31,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(1351.9 857.86) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.31,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(1351.9 857.86) rotate(180)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.41,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(912.1 857.86) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.41,
    y: 409.88,
    width: 31.28,
    height: 38.09,
    transform: "translate(912.1 857.86) rotate(180)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.99,
    y: 319.86,
    width: 305.51,
    height: 56.06,
    transform: "translate(587.49 695.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.5,
    y: 319.86,
    width: 240.05,
    height: 56.06,
    transform: "translate(1133.05 695.78) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.55,308.67c2,2.92,6.13,7.14,2.55,8.36a13.4,13.4,0,0,1-7.43,0s-29.4,3-50.4,3.88-60-2.07-62-2.36-6.05,2.81-7.43,2.13,1.7-6.77,1.7-7.94-7.66-20.27-10.19-32.78-2.8-25.25-3.08-26.72-5.33-8-3.68-9.62,9.71,3.2,10.43,3.45,37.15-10.1,57.87-9.72,49.74,5.76,50.46,5.76,8.88-4.1,10.84-2.82-1.75,9.34-1.44,10.37,7.12,19.19,9,29.55S398.55,308.67,398.55,308.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.87,311.78s.8-24.1-3.3-34.59-11.65-22.95-11.65-22.95,2.67,22.22,4.83,30.33C272.67,291.78,280.87,311.78,280.87,311.78Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.54,264.48c.35,1.18,37.57-13.07,37.57-13.07,11.22-.48,65.33,15.21,70.73,14.9,17.27-1,124.36,20.12,124.36,20.12l-8.57,37c-57.37,4.69-105.61-1.89-112.34-1.74-22.21.51-61.71,1.32-87.12.56-34.25-1-49.13-9.39-49.13-9.39S313.51,264.46,313.54,264.48Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.26,282.49s41.34,7.79,41.37,7.76c.94-.05,15-4.24,17.47-3.84,2.87.46,53.65,28.48,54.66,31.36s-4.69,7.51-12.48,7.78c-4.71.16-50.17-1.31-50.17-1.31l-48.88-.35Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.79,260.23s-15.33,50.14-16.65,63.52c0,0-72.18,3.38-93.1-10.9l24.5-48.37,36.74-14.31Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.41,282.85s41.34,7.78,41.37,7.75c.94-.05,15-4.24,17.48-3.84,2.86.46,53.65,28.48,54.65,31.36s-4.69,7.51-12.48,7.78c-4.71.16-50.17-1.31-50.17-1.31l-48.87-.34Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.62,279.5S401.87,320,418.7,322.69c10.1,1.61,73.53,2.64,131.58,1.84l4.93-34.21C500.64,269,437.84,271.2,433.73,270.19c-3.1-.76-32.57-26.49-69.21-28.61-23.34-1.34-43,7.78-43,7.78Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.61,266.27l6.15,3.87h0a484.58,484.58,0,0,1,54.5,3.55,300,300,0,0,1,53.43,11.37c4.35,1.37,8.66,2.89,12.94,4.42.53.18,1.07.37,1.6.52a2.68,2.68,0,0,0,.7.15,5.9,5.9,0,0,0,.76-.1c1.08-.22,2.17-.54,3.26-.84,2.18-.63,4.36-1.3,6.58-1.88,1.11-.28,2.22-.55,3.36-.76a11,11,0,0,1,3.55-.21,17.9,17.9,0,0,1,3.3,1.19c1,.47,2.08,1,3.1,1.48,4.08,2.05,8.05,4.29,12,6.56,1,.57,2,1.15,3,1.66l3,1.6c2,1.07,4,2.17,6,3.28,4,2.23,7.91,4.51,11.79,6.9,1.94,1.2,3.86,2.42,5.76,3.68a58.66,58.66,0,0,1,5.52,4,4.47,4.47,0,0,1,1.14,1.33,2.78,2.78,0,0,1-.19,1.73,7.29,7.29,0,0,1-2.1,2.69,12.24,12.24,0,0,1-6.23,2.62,12.15,12.15,0,0,0,6.16-2.7,7.1,7.1,0,0,0,2-2.67,2.58,2.58,0,0,0,.16-1.61,4.34,4.34,0,0,0-1.1-1.22,60.39,60.39,0,0,0-5.56-3.92c-1.91-1.23-3.85-2.41-5.81-3.57q-5.87-3.5-11.85-6.76c-2-1.09-4-2.17-6-3.22s-4.08-2.05-6-3.21c-4-2.24-8-4.41-12-6.45-1-.5-2-1-3.07-1.45a17.13,17.13,0,0,0-3.11-1.12,10.54,10.54,0,0,0-3.23.22c-1.1.21-2.2.48-3.29.76-2.19.58-4.36,1.25-6.55,1.89-1.1.32-2.19.64-3.35.87a5.12,5.12,0,0,1-.93.12,2.18,2.18,0,0,1-.52-.06l-.44-.12c-.57-.16-1.11-.35-1.65-.53-4.3-1.52-8.58-3-12.92-4.36a303.41,303.41,0,0,0-53.24-11.5c-9-1.2-18.07-2.1-27.14-2.81s-18.16-1.25-27.26-1.44h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.79,307.24s16.74-37.06,34.22-55.15c0,0-41.12-24-86.49-2.73l-15.9,30.14S357.88,301.66,373.79,307.24Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.56,322a84.07,84.07,0,0,1-9.62-2.42c-3.17-.95-6.31-2-9.43-3.11s-6.22-2.25-9.32-3.41-6.16-2.4-9.23-3.63c-6.14-2.47-12.26-5-18.33-7.62s-12.13-5.27-18.14-8l.24,0c-4.53.82-9.09,1.35-13.66,1.72-2.29.16-4.57.29-6.87.35s-4.58.07-6.87,0c4.58-.13,9.15-.39,13.7-.88s9.08-1.09,13.54-2l.12,0,.12.05c6.06,2.64,12.11,5.29,18.2,7.86s12.17,5.16,18.29,7.66,12.25,5,18.43,7.29A161.56,161.56,0,0,0,415.56,322Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,308.86c2,2.92,6.13,7.14,2.55,8.37a13.41,13.41,0,0,1-7.43,0s-29.39,3-50.4,3.87-60-2.06-62-2.36-6,2.81-7.43,2.13,1.7-6.76,1.7-7.94-7.66-20.27-10.19-32.77-2.8-25.25-3.08-26.73-5.33-8-3.68-9.62,9.71,3.2,10.43,3.46,37.15-10.11,57.87-9.73,49.74,5.76,50.46,5.76,8.88-4.09,10.84-2.81-1.75,9.34-1.44,10.36,7.12,19.19,9,29.55S282,308.86,282,308.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,312s.8-24.1-3.3-34.59-11.65-23-11.65-23,2.67,22.23,4.83,30.33C156.16,292,164.36,312,164.36,312Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.85,223.22c16.27,2.13,33.93,26.65,34,51.2,0,26.52-23.09,39.05-38.9,38.47-16.78-.61-26.68-15.75-23.05-27.88,3.51-11.72,13.44-18.05,13.55-27.77.06-4.65-2.63-12.34-2.85-19.21C199.35,230.36,207,221.94,216.85,223.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.53,225.28a63.16,63.16,0,0,1,19.25,16.55,50.86,50.86,0,0,1,6.48,11,49.45,49.45,0,0,1,2.1,6.07,60.82,60.82,0,0,1,1.3,6.28c1.21,8.43.48,17.35-3.24,25.13A36.42,36.42,0,0,1,242,300.72a37,37,0,0,1-10.54,7.1A37.11,37.11,0,0,0,248.79,290a43.71,43.71,0,0,0,3-24.7,58.94,58.94,0,0,0-1.24-6.19,46.58,46.58,0,0,0-2-6,53.11,53.11,0,0,0-6.28-10.94,63.44,63.44,0,0,0-8.53-9.34A65.72,65.72,0,0,0,223.53,225.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.71,246.51a38.93,38.93,0,0,1,1.2,7,22.56,22.56,0,0,1-.64,7.08,18.81,18.81,0,0,1-3.11,6.45c-1.42,1.88-2.82,3.75-4.12,5.69a34.83,34.83,0,0,0-5.73,12.61,21,21,0,0,0,1.8,13.6,20.49,20.49,0,0,1-2.48-6.61,18.41,18.41,0,0,1-.3-3.56,20.11,20.11,0,0,1,.31-3.55c.79-4.74,3.06-9.06,5.65-13,1.32-2,2.78-3.84,4.2-5.69a19.42,19.42,0,0,0,3.1-6.14C201.94,255.92,201.51,251.12,200.71,246.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.31,309.2l30,11,14.25-70.81s-39.77-2.71-65-2.52c-12.6.1-18.83,8-18.32,17.07.13,2.3,10.57,36.45,19.16,41.46A29.55,29.55,0,0,0,277.31,309.2Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.16,287.37a51.92,51.92,0,0,0-1.44,8.87c-.09,1.5-.1,3-.07,4.51,0,.75,0,1.5,0,2.25a8.15,8.15,0,0,1-.31,2.31c0,.06.09.1.12,0a12.72,12.72,0,0,0,.7-2.08,13.56,13.56,0,0,0,.29-2.11c.11-1.52.13-3.05.22-4.57.18-3.07.37-6.13.8-9.15C279.46,287.3,279.19,287.23,279.16,287.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.55,281.53a57.88,57.88,0,0,0-2.91,6.78,36.81,36.81,0,0,0-1,3.55c-.14.57-.27,1.15-.39,1.72s-.16,1.3-.3,1.93c0,.07.1.11.12.05.15-.6.42-1.16.61-1.74s.38-1.16.58-1.74c.39-1.17.79-2.33,1.16-3.5.75-2.34,1.53-4.66,2.37-7C284.82,281.49,284.61,281.42,284.55,281.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,269.06c-11,30.94-20.56,45.06-30.41,45.67-8.51.53-27.44-13.55-35.32-29.28-1-2,21.49-11.58,23.37-9.88,4.26,3.84,9.77,9.85,10.95,10.09,1.93.39,11.39-15.44,23.82-27.57C257.84,247.26,258.85,256.37,254.33,269.06Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.71,288.15c-2.09-2.42-9.11-12.24-11.79-20.26-1.3-3.89-3.85-15.46-.94-16.68s4,2.09,4,2.09-.34-5.05,2.7-6,4.5,4.24,4.5,4.24,0-5.21,3.12-6,3.69,4.74,3.69,4.74-.2-4.77,2.62-4.31c3.38.56,2.76,9.38,4.42,13.61.37,1,9,18.93,9,18.93Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,250.37c-.44,6.49.49,9.4,3.53,15,.06.11-.09.22-.16.11-3.49-5.24-5.18-8.73-3.69-15.19C195.77,250,196,250.06,196,250.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.06,251.26c.13,6.78,1.11,9.95,3.87,16.09,0,.09-.11.16-.16.08-3.2-5.8-4.81-9.32-4.05-16.11C188.75,251,189.05,251,189.06,251.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,253.85c.6,6.56,1.53,10.09,5,15.7a.12.12,0,0,1-.2.14c-4.06-5.39-5.25-9.77-5-15.8C181.8,253.48,181.94,253.44,182,253.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,279.35s1.38-8,1.21-11.7-5.84-17.09-8.81-16c-3.83,1.37-2.08,9.76-.69,13.76,0,0-8.87,3.15-8.92,9.44S212.84,279.35,212.84,279.35Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.31,252.34c-2.59,3.77-.43,8.9.63,12.88a.37.37,0,0,1-.37.49c-3.63,1.57-8.29,4.84-9.12,8.93a.1.1,0,0,1-.19,0c.29-4.51,4.61-8.09,8.69-9.56-1.15-4.06-3.09-9.3.33-12.74C204.3,252.3,204.33,252.32,204.31,252.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,293.71l-21-13.82s11.34-15.88,19.82-24.11,14.46-7.78,10.26,9A249.5,249.5,0,0,1,247.59,293.71Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.11,277.09q4.69,2.49,9.25,5.21c1.5.9,3,1.77,4.5,2.7s3,2,4.53,3a.1.1,0,0,1-.1.18c-1.51-.87-3.08-1.63-4.6-2.48s-3.1-1.83-4.64-2.75q-4.58-2.73-9-5.68C230,277.17,230,277,230.11,277.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,270.37c-9.14,35.18-14.28,50.35-22,52.93-11.79,4-35.73-19.52-46.66-30.12-1.65-1.59,15-26.17,16.92-24.43,9.87,9,22.52,22,24.29,21.41s5.88-12.32,15.76-28.22C261,248.53,268,256,264.27,270.37Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,283.36a71.77,71.77,0,0,1,9.22,7.07l.36-.45a8.64,8.64,0,0,0,.57-.78,15.25,15.25,0,0,0,.91-1.69c.06-.12.25,0,.21.09a16.54,16.54,0,0,1-.79,1.83,3.33,3.33,0,0,1-1,1.24c3.54,3.17,6.88,6.59,10.14,10,.1.1-.06.26-.16.16-3.07-3.1-6.39-6-9.65-8.87s-6.65-5.61-9.86-8.54C227.55,283.4,227.6,283.33,227.64,283.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.45,276.06S208,259.43,198.61,253.75c-4-2.38-22.48-8.56-24.13-4.13-1.5,4,15,7.5,15,7.5s-16.35-5-17.26.16,18.27,6.63,18.27,6.63-16.92-4.76-17,.7c-.08,4.14,17.22,6.45,17.22,6.45s-14.57-4-14.82.25c-.29,4.69,15.54,7.83,15.54,7.83-.48,7.9,1.66,12.12,5.63,15.06C198,294.91,218.45,276.06,218.45,276.06Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,258.49c-1.9-.66-3.81-1.33-5.77-1.82s-3.92-.9-5.9-1.21a34.68,34.68,0,0,0-7.85-.44c4.68.07,11.69,1.7,13.64,2.19s3.92.87,5.87,1.36C195.3,258.58,195.31,258.51,195.26,258.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.64,265.57c-2.47-.74-4.88-1.55-7.38-2.18s-4.89-1-7.41-1.45c-.19,0-.15.09.05.13,2.5.55,4.76,1.25,7.26,1.83s5,1.06,7.46,1.73C193.66,265.64,193.67,265.58,193.64,265.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33,271.89a57.19,57.19,0,0,0-11.53-2.46c-.19,0-.11.11.08.15,3.85.75,6.87,1.31,11.41,2.44C193.36,272,193.41,271.92,193.33,271.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,261.94a8.69,8.69,0,0,0-4.15.9,2,2,0,0,0-1.07,1.65,2.24,2.24,0,0,0,1,1.71,13.17,13.17,0,0,0,3.79,1.88c1.35.47,2.73.84,4.12,1.19l-.1.49a16.68,16.68,0,0,0-3.16-.1,4.19,4.19,0,0,0-2.75.94,1.56,1.56,0,0,0-.28,1.26,2.65,2.65,0,0,0,.64,1.27,8.27,8.27,0,0,0,2.48,1.81,31.41,31.41,0,0,0,6,2.19c2.05.59,4.14,1.12,6.21,1.65l.32.08,0,.33a19.48,19.48,0,0,0,1.35,9.51,14.86,14.86,0,0,0,2.57,4.09c1.1,1.2,2.24,2.4,3.42,3.55,2.34,2.32,4.77,4.56,7.2,6.79s4.88,4.45,7.36,6.63c-5.11-4.19-10.15-8.46-15-13-1.2-1.14-2.38-2.3-3.51-3.52a15.92,15.92,0,0,1-2.71-4.25,20.13,20.13,0,0,1-1.46-9.89l.28.42c-2.1-.51-4.17-1.08-6.24-1.68a32.81,32.81,0,0,1-6.1-2.28,9.31,9.31,0,0,1-2.67-2,2.64,2.64,0,0,1-.33-3.36,2.94,2.94,0,0,1,1.55-.86,7.83,7.83,0,0,1,1.65-.24,17,17,0,0,1,3.27.17l-.1.5c-1.4-.38-2.78-.78-4.14-1.28a12.76,12.76,0,0,1-3.85-2.05,2.53,2.53,0,0,1-1-1.95,2.15,2.15,0,0,1,1.23-1.77A8.67,8.67,0,0,1,178.85,261.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.73,248.07a66.79,66.79,0,0,1,11,1.9,44.34,44.34,0,0,1,5.36,1.68,19.28,19.28,0,0,1,5,2.71,41.61,41.61,0,0,1,4.19,3.76c1.32,1.32,2.61,2.68,3.85,4.08a98.09,98.09,0,0,1,7,8.77v0l1.84,1.85-2-1.72h0c-2.3-2.92-4.77-5.72-7.29-8.44a69.18,69.18,0,0,0-8-7.68,18.21,18.21,0,0,0-4.78-2.67c-1.71-.69-3.48-1.25-5.26-1.78s-3.59-1-5.4-1.37S180.57,248.34,178.73,248.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.17,295.31l-22.63-11s6.91-15.17,14.24-24.43,15.6-11.66,13.62,5.51A248.7,248.7,0,0,1,261.17,295.31Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.69,281.11q5,1.86,9.85,4c1.6.69,3.22,1.37,4.8,2.09s3.24,1.61,4.88,2.35c.12.05,0,.24-.07.19-1.61-.66-3.27-1.21-4.88-1.87s-3.31-1.41-5-2.12q-4.89-2.1-9.68-4.45C241.54,281.21,241.59,281.07,241.69,281.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.37,294c.13,0,2.8,1.33,2.84,1.35.55-3.64,1.57-7.18,2.32-10.78s1.49-7.32,2.1-11a.07.07,0,0,1,.14,0c-.21,1.84-.38,3.7-.65,5.54-.13.91-.29,1.82-.47,2.73.15-.34.27-.69.42-1,.45-1,1-2,1.51-2.95,0-.05.11,0,.09,0a31.57,31.57,0,0,1-1.21,3.1c-.33.73-.7,1.44-1.06,2.16-.1.52-.21,1.05-.31,1.58a64.16,64.16,0,0,1-2.65,11.13s-3-1.68-3.13-1.77S258.29,293.94,258.37,294Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,285.67c-.12-.06-2.79-1.79-2.84-1.81,1.84-3.19,3-5.5,4.68-8.79s1.86-3.66,3.67-6.91c0-.08-.07-.15-.12-.08-1,1.58-2,3.13-3,4.74-.46.79-.9,1.61-1.34,2.42.11-.35.22-.7.32-1.06a32,32,0,0,0,.65-3.24c0-.06-.08-.07-.1,0-.37,1-.71,2.1-1,3.17-.2.78-.35,1.57-.52,2.35a39.43,39.43,0,0,0-3.84,7.72s3.19,1.66,3.33,1.64A.07.07,0,0,0,241.22,285.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.72,253.53c.84,1,3.72,10.85,0,15.31-1.22,1.45-9.43-4.86-9.43-4.86l-.72-.33-10-4.59,1.2-14.91.25-2.09s2.65,1.43,5.93,3.25l.46.26.54.29c.49.27,1,.54,1.49.82s.75.42,1.14.66l1.17.69A70.38,70.38,0,0,1,245.72,253.53Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,245.31a22,22,0,0,1,2.59,18.34l-10-4.59,1.2-14.91.25-2.09S229.68,243.49,233,245.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,258.42c11.83,15.22,22.28,9.85,25.55,7.29,3-2.32,12.82-10.59,2.62-26.95s-21-15.66-28.09-10.72S189.43,243.2,201.26,258.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.28,255.68c.3-.34.52-.7.79-1.07a2.24,2.24,0,0,0,.59-1.25.67.67,0,0,0-.56-.62,1.69,1.69,0,0,0-1.51.82,2.53,2.53,0,0,0-.58,1.7A.73.73,0,0,0,203.28,255.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.36,247.32a11.09,11.09,0,0,1-1.15.67,2.19,2.19,0,0,1-1.31.45.69.69,0,0,1-.56-.62,1.71,1.71,0,0,1,1-1.42,2.51,2.51,0,0,1,1.75-.39A.73.73,0,0,1,212.36,247.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84,258.75a2.1,2.1,0,0,1-.23,1.33,3.5,3.5,0,0,1-1.23.77,0,0,0,0,0,0,.09,1.77,1.77,0,0,0,1.68-.69,1.42,1.42,0,0,0-.1-1.55C219.93,258.63,219.84,258.69,219.84,258.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,258.91s1.12,1.63,1.74,2.32c.06.07.25-.05.49-.25,0,0,0,0,0,0a4.38,4.38,0,0,0,2.07-4.07.1.1,0,0,0-.19,0,6.62,6.62,0,0,1-2.21,3.55c-.22-.15-1.81-2.87-1.93-2.78a8,8,0,0,0-1.23,1.76c-2.42-3.34-4.28-7-6.74-10.33a.13.13,0,0,0-.22.12,66.84,66.84,0,0,0,6.78,11.43C211.47,261.06,212.42,259.27,212.58,258.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,251.67s.11,0,.15,0c.91.91,2.11,1.8,3.22,1.24,0,0,.08,0,.05.06C215.18,253.88,213.6,252.68,212.88,251.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.23,249.42a4.1,4.1,0,0,1,.52.5,1.87,1.87,0,0,0,.56.12,1,1,0,0,0,.95-.47c.39-.68-.07-1.42-.68-1.93,0,0-.09,0-.08,0,.14.51.26,1.06-.07,1.38s-.79.26-1.17.37h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,252.66a2,2,0,0,0,1,.32,1.4,1.4,0,0,0,1-.45,1.25,1.25,0,0,0,.29-1.11,2.15,2.15,0,0,0-.45-.92,3.05,3.05,0,0,0-.43-.45,2.73,2.73,0,0,0-1.1-.64,5.06,5.06,0,0,1,.65.66,6.22,6.22,0,0,1,.48.7c.29.5.41,1,.09,1.35a1.11,1.11,0,0,1-1.34.1,9.21,9.21,0,0,1-1.53-.93A4.14,4.14,0,0,0,213.87,252.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.57,256.82s0,.1,0,.15c.78,1,1.49,2.34.78,3.36,0,0,0,.09,0,.06C209.43,259.4,208.47,257.67,207.57,256.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.15,257.83a4.19,4.19,0,0,0,.42.59,2.22,2.22,0,0,1,0,.57,1,1,0,0,1-.6.87c-.73.29-1.4-.27-1.81-.94,0-.05,0-.09,0-.08.48.21,1,.41,1.37.13s.37-.75.53-1.11c0,0,0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4,257.94a2,2,0,0,1,.19,1,1.42,1.42,0,0,1-.6,1,1.29,1.29,0,0,1-1.14.14,2.15,2.15,0,0,1-.85-.58,3.48,3.48,0,0,1-.38-.48,2.73,2.73,0,0,1-.48-1.19,4.16,4.16,0,0,0,.57.74,5.43,5.43,0,0,0,.61.57c.46.36,1,.55,1.33.28a1.11,1.11,0,0,0,.29-1.31,9.18,9.18,0,0,0-.7-1.64A4.05,4.05,0,0,1,208.4,257.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,240.18c-2.18,2.24-7-2.2-7-2.2s-4.76,4.2-12.35-1.28a14,14,0,0,0,7.09,3.82s-9.19,6.49-18.91,2.57c0,0,4.56,2.34,7,2.45,0,0-4.39,2.11-8.62.76,0,0,2.09,5.36,1.94,7.47,0,0-12.57-15,2.43-25.42,0,0,9-6.93,18-2.86S228.91,240.18,228.91,240.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,242.87s-1-7.27,2-8,6.63,7.79,5.09,10.84a3.25,3.25,0,0,1-4.39,1.69Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,237.32s.09,0,.07.05c-1,2.2-.49,4.53.38,6.68a1.79,1.79,0,0,1,1.64-2.19c.07,0,.09.1,0,.13a2,2,0,0,0-1.14,2,9.56,9.56,0,0,0,.44,2c.06.22-.28.39-.38.16a.08.08,0,0,1,0-.05C228,244.08,226.89,239.63,229,237.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,253.77q1.57,2.28,3.3,4.42a46,46,0,0,0,3.67,4.09,29.27,29.27,0,0,0,4.16,3.54,16.93,16.93,0,0,0,4.91,2.38,14.26,14.26,0,0,1-5.12-2.06,25.94,25.94,0,0,1-4.31-3.51,40.1,40.1,0,0,1-3.61-4.21A37.23,37.23,0,0,1,198,253.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.55,375.92s3-54.57,0-56.76c-4.73-3.47-41.92-.48-44.43-1.49s-52.82-32.16-56.9-32.76-6.76.66-7.42.66-1.86-1.2-5-1.14-12.4,3.11-12.4,3.11-76.1-28.49-130-23.29c-1.86.18-26.44-24.64-59.9-25.52s-48,8.47-49.76,8.1-46.71-1.72-51.39-.84S253.56,272,249.79,275s-26.56,21.73-32.86,29.09-12,37.19-13.75,39.89-12.68,30.36-11.78,35.39,24.2-3.49,42.55-3.49Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,272.9a8.08,8.08,0,0,1-1.43-3.55c-.18-1-.24-2-.47-2.92a1.45,1.45,0,0,1-.3.05c.05.52,0,1,.05,1.53,0,.91.07,1.2,0,2.11a7.54,7.54,0,0,1-1.08,3.82c-.21.32-.55.86-1,.63s-.48-1.19-.5-1.62a9.15,9.15,0,0,1,.43-3.42,10,10,0,0,1,.88-2.17c.18-.34.39-.68.57-1l-.05-.05a21,21,0,0,1-2.21,3.26,14,14,0,0,1-1.43,1.45,7.55,7.55,0,0,1-1.4,1.08c-.23.12-.84.48-1,.09s.2-1.17.45-1.6a7.65,7.65,0,0,1,1.13-1.65,13.81,13.81,0,0,1,1.54-1.25,23.89,23.89,0,0,1,2.51-1.74s-.05,0-.05-.07a28.51,28.51,0,0,1-3.09,1,10.55,10.55,0,0,1-4,.54c-.36,0-.74-.16-.74-.59s.58-.81.95-1a7.27,7.27,0,0,1,1.6-.75,6,6,0,0,1,1.9-.07c1.09.09,2.17.23,3.24.32a.18.18,0,0,1,0-.09c-1-.34-2.06-.77-3.12-1.07a6.27,6.27,0,0,1-3.17-1.6c-.25-.27-.7-.84-.59-1.22s.84-.25,1.13-.18a9.62,9.62,0,0,1,3.55,1.76c.8.54,1.66,1.06,2.42,1.65l.09-.11c-.24-.25-.45-.5-.7-.73-.54-.49-1.15-.85-1.69-1.35a7,7,0,0,1-1.81-2.9c-.09-.31-.25-1,.18-1.2s1,.32,1.24.52a8.05,8.05,0,0,1,2.17,2.9,19.61,19.61,0,0,1,1.07,2.44c-.14-.72-.27-1.42-.36-2.15a7.26,7.26,0,0,1,.36-3.89c.18-.43,1.33-2.35,1.81-1.17a4.83,4.83,0,0,1,.13,1.9,11.23,11.23,0,0,1-.29,2.15c-.23,1.08-.54,2.14-.86,3.21a.91.91,0,0,1,.25.11,28.44,28.44,0,0,1,1.85-2.9,6.22,6.22,0,0,1,2.76-2.21c.34-.14,1-.5,1.36-.16s0,.86-.14,1.15a7,7,0,0,1-2.76,2.6L284.86,264c-.31.2-.63.38-.93.58a.51.51,0,0,1,.14.21l.27-.18a11.92,11.92,0,0,1,2.9-1.5,7.54,7.54,0,0,1,1.9-.38,6.64,6.64,0,0,1,2,0,1.3,1.3,0,0,1,1.11.73c.15.47-.25.88-.62,1.1a3,3,0,0,1-1.49.41c-.74.07-1.47.11-2.19.16l-3.71.25a.34.34,0,0,1-.05.22,16.25,16.25,0,0,1,3.49.8,8.81,8.81,0,0,1,3.28,1.87c.24.27.77.75.54,1.16s-1,.31-1.4.22a11.49,11.49,0,0,1-3.58-1.76c-.88-.57-1.74-1.2-2.58-1.83a.31.31,0,0,1-.18.16,11.61,11.61,0,0,1,.86,1.13,16.77,16.77,0,0,1,1.47,2.05,11.36,11.36,0,0,1,1.09,3.87c0,.39,0,1-.54.84A3,3,0,0,1,285.27,272.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.78,352.89a8,8,0,0,1-1.42-3.55c-.18-1-.25-2-.48-2.92a1.47,1.47,0,0,1-.29.05c0,.52,0,1,0,1.54,0,.9.07,1.19,0,2.1a7.55,7.55,0,0,1-1.09,3.82c-.2.32-.54.86-1,.63s-.47-1.19-.49-1.62a9,9,0,0,1,.43-3.42,9.07,9.07,0,0,1,.88-2.17c.18-.34.38-.68.56-1l0-.05a21.75,21.75,0,0,1-2.22,3.26,15,15,0,0,1-1.42,1.45,7.31,7.31,0,0,1-1.41,1.08c-.22.12-.83.48-1,.09s.2-1.17.45-1.6a7.65,7.65,0,0,1,1.13-1.65,13.81,13.81,0,0,1,1.54-1.25,25,25,0,0,1,2.51-1.74.1.1,0,0,1,0-.07,29.41,29.41,0,0,1-3.1,1,10.53,10.53,0,0,1-4,.54c-.37,0-.75-.16-.75-.59s.59-.81.95-1a7.13,7.13,0,0,1,1.61-.75,6,6,0,0,1,1.89-.07c1.09.09,2.18.23,3.24.32a.18.18,0,0,1,0-.09c-1-.34-2.06-.77-3.12-1.06a6.37,6.37,0,0,1-3.17-1.61c-.24-.27-.7-.84-.58-1.22s.83-.25,1.13-.18a9.69,9.69,0,0,1,3.55,1.76c.79.54,1.65,1.06,2.42,1.65a.53.53,0,0,1,.09-.11c-.25-.25-.45-.5-.7-.72-.55-.5-1.16-.86-1.7-1.36a7.09,7.09,0,0,1-1.81-2.9c-.09-.31-.25-1,.18-1.2s1,.32,1.25.52a8.17,8.17,0,0,1,2.17,2.9,18.75,18.75,0,0,1,1.06,2.44c-.13-.72-.27-1.42-.36-2.15a7.37,7.37,0,0,1,.36-3.89c.18-.43,1.34-2.35,1.81-1.17a4.83,4.83,0,0,1,.14,1.9,12,12,0,0,1-.3,2.15c-.22,1.08-.54,2.14-.86,3.21a1.36,1.36,0,0,1,.25.11,30.22,30.22,0,0,1,1.86-2.89,6.07,6.07,0,0,1,2.76-2.22c.33-.14,1-.5,1.35-.16s0,.86-.13,1.15a7.22,7.22,0,0,1-2.76,2.61L268.38,344c-.32.2-.64.38-.93.59a.41.41,0,0,1,.13.2c.09-.07.18-.11.28-.18a11.68,11.68,0,0,1,2.89-1.5,8,8,0,0,1,1.9-.38,6.63,6.63,0,0,1,2,0,1.3,1.3,0,0,1,1.11.73c.16.47-.25.88-.61,1.11a3,3,0,0,1-1.49.4c-.75.07-1.47.12-2.2.16l-3.71.25a.47.47,0,0,1,0,.23,15.57,15.57,0,0,1,3.48.79,8.66,8.66,0,0,1,3.28,1.87c.25.28.77.75.54,1.16s-1,.31-1.4.22a11.33,11.33,0,0,1-3.57-1.76c-.89-.57-1.75-1.2-2.58-1.83a.34.34,0,0,1-.18.16,13.45,13.45,0,0,1,.86,1.13,18,18,0,0,1,1.47,2.06,11.46,11.46,0,0,1,1.08,3.86c.05.39,0,1-.54.84A3,3,0,0,1,268.78,352.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.81,289.69a8.08,8.08,0,0,1-1.43-3.55c-.18-1-.25-2-.47-2.92a1.54,1.54,0,0,1-.3,0c.05.53,0,1,.05,1.54,0,.91.07,1.2,0,2.11a7.64,7.64,0,0,1-1.08,3.82c-.21.32-.55.86-1,.63s-.48-1.2-.5-1.63a9.13,9.13,0,0,1,.43-3.41,9.5,9.5,0,0,1,.88-2.17c.18-.34.39-.68.57-1l0-.05a21.7,21.7,0,0,1-2.21,3.26,15,15,0,0,1-1.43,1.45,7.55,7.55,0,0,1-1.4,1.08c-.23.11-.84.48-1,.09s.2-1.17.45-1.6a8,8,0,0,1,1.13-1.66,13.93,13.93,0,0,1,1.54-1.24,23.89,23.89,0,0,1,2.51-1.74s0-.05,0-.07a28.68,28.68,0,0,1-3.1,1,10.5,10.5,0,0,1-4,.54c-.36-.05-.75-.16-.75-.59s.59-.81.95-1a7.56,7.56,0,0,1,1.61-.74,5.76,5.76,0,0,1,1.9-.07c1.09.09,2.17.23,3.23.32a.12.12,0,0,1,0-.09c-1-.34-2.06-.77-3.12-1.07a6.31,6.31,0,0,1-3.17-1.6c-.25-.27-.7-.84-.59-1.22s.84-.25,1.13-.19a9.79,9.79,0,0,1,3.55,1.77c.79.54,1.65,1.06,2.42,1.65a.59.59,0,0,1,.09-.11c-.25-.25-.45-.5-.7-.73-.54-.49-1.15-.86-1.69-1.35a7.05,7.05,0,0,1-1.81-2.9c-.09-.32-.25-1,.18-1.2s1,.32,1.24.52a8.08,8.08,0,0,1,2.17,2.9,19.61,19.61,0,0,1,1.07,2.44c-.14-.72-.28-1.42-.37-2.15a7.37,7.37,0,0,1,.37-3.89c.18-.43,1.33-2.35,1.81-1.18a5.05,5.05,0,0,1,.13,1.9,11,11,0,0,1-.29,2.15c-.23,1.09-.55,2.15-.86,3.22a.91.91,0,0,1,.25.11,28.44,28.44,0,0,1,1.85-2.9,6.17,6.17,0,0,1,2.76-2.21c.34-.14,1-.5,1.36-.16s0,.86-.14,1.15a7,7,0,0,1-2.76,2.6l-1.83,1.22-.93.59a.51.51,0,0,1,.14.21l.27-.19a11.54,11.54,0,0,1,2.9-1.49,7.54,7.54,0,0,1,1.9-.38,6.32,6.32,0,0,1,2,0c.43.07,1,.27,1.1.72s-.24.89-.61,1.11a3.05,3.05,0,0,1-1.49.41c-.75.07-1.47.11-2.19.16l-3.71.25a.37.37,0,0,1,0,.22,16.85,16.85,0,0,1,3.49.79,8.85,8.85,0,0,1,3.27,1.88c.25.27.77.75.55,1.16s-1,.31-1.4.22a11.49,11.49,0,0,1-3.58-1.76c-.88-.57-1.74-1.2-2.58-1.83a.26.26,0,0,1-.18.15c.32.37.59.75.86,1.13a19,19,0,0,1,1.47,2.06,11.59,11.59,0,0,1,1.09,3.87c0,.38,0,1-.55.84A3.06,3.06,0,0,1,352.81,289.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.2,301.4a8.11,8.11,0,0,1-1.42-3.56c-.18-1-.25-2-.48-2.91a1.45,1.45,0,0,1-.29,0c0,.52,0,1,0,1.54,0,.9.06,1.2,0,2.1a7.56,7.56,0,0,1-1.09,3.83c-.2.31-.54.86-1,.63s-.47-1.2-.49-1.63a8.93,8.93,0,0,1,.43-3.41,9.31,9.31,0,0,1,.88-2.18c.18-.34.38-.67.56-1l0,0a22.28,22.28,0,0,1-2.22,3.26,13.79,13.79,0,0,1-1.42,1.44,7.6,7.6,0,0,1-1.4,1.09c-.23.11-.84.47-1,.09s.21-1.18.46-1.61a7.43,7.43,0,0,1,1.13-1.65,12.77,12.77,0,0,1,1.53-1.24,23.44,23.44,0,0,1,2.51-1.74s0-.05,0-.07a31.86,31.86,0,0,1-3.1,1,10.34,10.34,0,0,1-4,.55c-.36-.05-.75-.16-.75-.59s.59-.82,1-1a7.59,7.59,0,0,1,1.61-.75,6,6,0,0,1,1.9-.06c1.08.09,2.17.22,3.23.31a.2.2,0,0,1,0-.09c-1-.34-2-.77-3.12-1.06a6.3,6.3,0,0,1-3.16-1.61c-.25-.27-.71-.83-.59-1.22s.83-.25,1.13-.18a9.64,9.64,0,0,1,3.55,1.77c.79.54,1.65,1.06,2.42,1.65a.62.62,0,0,1,.09-.12c-.25-.24-.45-.49-.7-.72-.54-.5-1.15-.86-1.7-1.36a7.12,7.12,0,0,1-1.81-2.89c-.09-.32-.25-1,.18-1.2s1,.32,1.25.52a8,8,0,0,1,2.17,2.89,18.87,18.87,0,0,1,1.06,2.45c-.13-.73-.27-1.43-.36-2.15a7.36,7.36,0,0,1,.36-3.89c.18-.43,1.34-2.35,1.81-1.18a4.83,4.83,0,0,1,.14,1.9,11,11,0,0,1-.3,2.15c-.22,1.09-.54,2.15-.86,3.21a1.42,1.42,0,0,1,.25.12,30.37,30.37,0,0,1,1.86-2.9,6.13,6.13,0,0,1,2.76-2.22c.34-.13,1-.49,1.35-.15s0,.85-.13,1.15a7.12,7.12,0,0,1-2.76,2.6l-1.83,1.22c-.32.21-.64.39-.93.59a.73.73,0,0,1,.14.2c.09-.06.18-.11.27-.18a11.64,11.64,0,0,1,2.89-1.49,8.12,8.12,0,0,1,1.9-.39,6.62,6.62,0,0,1,2,0c.43.07,1,.27,1.11.72s-.25.88-.61,1.11a3.17,3.17,0,0,1-1.49.41l-2.2.15c-1.24.1-2.46.16-3.71.25a.47.47,0,0,1,0,.23,16.76,16.76,0,0,1,3.48.79,8.81,8.81,0,0,1,3.28,1.88c.25.27.77.75.54,1.15s-1,.32-1.4.23a11.25,11.25,0,0,1-3.57-1.77c-.88-.56-1.74-1.19-2.58-1.83a.3.3,0,0,1-.18.16,13,13,0,0,1,.86,1.13,19,19,0,0,1,1.47,2.06,11.58,11.58,0,0,1,1.08,3.87c0,.38,0,1-.54.83A3,3,0,0,1,537.2,301.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.22,333.94a8.08,8.08,0,0,1-1.43-3.55c-.18-1-.24-2-.47-2.92a1.45,1.45,0,0,1-.29,0c0,.53,0,1,0,1.54,0,.91.07,1.2,0,2.11A7.54,7.54,0,0,1,681,335c-.21.32-.55.86-1,.63s-.48-1.2-.5-1.63a9.13,9.13,0,0,1,.43-3.41,10,10,0,0,1,.88-2.17c.18-.34.39-.68.57-1l0-.05a21,21,0,0,1-2.21,3.26,15,15,0,0,1-1.43,1.45,7.55,7.55,0,0,1-1.4,1.08c-.23.11-.84.48-1,.09s.2-1.17.45-1.6a8,8,0,0,1,1.13-1.66,14.93,14.93,0,0,1,1.54-1.24,23.89,23.89,0,0,1,2.51-1.74s-.05-.05-.05-.07a28.51,28.51,0,0,1-3.09,1,10.55,10.55,0,0,1-4,.54c-.36-.05-.74-.16-.74-.59s.58-.81,1-1a7.71,7.71,0,0,1,1.6-.74,5.76,5.76,0,0,1,1.9-.07c1.09.09,2.17.23,3.24.32a.16.16,0,0,1,0-.09c-1-.34-2.06-.77-3.12-1.07a6.35,6.35,0,0,1-3.17-1.6c-.25-.27-.7-.84-.59-1.22s.84-.25,1.13-.19a9.79,9.79,0,0,1,3.55,1.77c.8.54,1.66,1.06,2.42,1.65a.36.36,0,0,1,.1-.11c-.25-.25-.46-.5-.71-.73-.54-.49-1.15-.86-1.69-1.35a7.05,7.05,0,0,1-1.81-2.9c-.09-.32-.25-1,.18-1.2s1,.32,1.24.52a8,8,0,0,1,2.17,2.9,19.61,19.61,0,0,1,1.07,2.44c-.14-.72-.27-1.42-.36-2.15a7.26,7.26,0,0,1,.36-3.89c.18-.43,1.33-2.35,1.81-1.18a4.85,4.85,0,0,1,.13,1.9,11,11,0,0,1-.29,2.15c-.23,1.09-.54,2.15-.86,3.22a.91.91,0,0,1,.25.11,28.44,28.44,0,0,1,1.85-2.9,6.22,6.22,0,0,1,2.76-2.21c.34-.14,1-.5,1.36-.16s0,.86-.14,1.15a7,7,0,0,1-2.76,2.6L683.81,325c-.31.21-.63.39-.93.59a.51.51,0,0,1,.14.21l.27-.19a11.88,11.88,0,0,1,2.9-1.49,7.54,7.54,0,0,1,1.9-.38,6.32,6.32,0,0,1,2,0c.43.07,1,.27,1.11.72s-.25.89-.62,1.11a3,3,0,0,1-1.49.41c-.74.07-1.47.11-2.19.16l-3.71.25a.37.37,0,0,1,0,.22,16.85,16.85,0,0,1,3.49.79,9,9,0,0,1,3.28,1.88c.25.27.77.75.54,1.16s-1,.31-1.4.22a11.49,11.49,0,0,1-3.58-1.76c-.88-.57-1.74-1.2-2.58-1.83a.26.26,0,0,1-.18.15c.32.37.59.75.86,1.13a17.68,17.68,0,0,1,1.47,2.06,11.36,11.36,0,0,1,1.09,3.87c0,.38,0,1-.54.84A3,3,0,0,1,684.22,333.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.08,343.83a8.07,8.07,0,0,1-1.42-3.55c-.18-1-.25-2-.48-2.92a1,1,0,0,1-.29.05c.05.52,0,1,.05,1.54,0,.9.06,1.2,0,2.1a7.55,7.55,0,0,1-1.09,3.82c-.2.32-.54.86-1,.64s-.47-1.2-.49-1.63a11.16,11.16,0,0,1,1.31-5.59c.18-.34.38-.68.56-1l0,0a21.66,21.66,0,0,1-2.22,3.25,13.89,13.89,0,0,1-1.42,1.45,8.05,8.05,0,0,1-1.4,1.09c-.23.11-.84.47-1,.09s.21-1.18.46-1.61a7,7,0,0,1,1.13-1.65,11.86,11.86,0,0,1,1.53-1.24,23.53,23.53,0,0,1,2.51-1.75s0,0,0-.06a31.86,31.86,0,0,1-3.1,1,10.53,10.53,0,0,1-4,.54c-.36,0-.75-.15-.75-.58s.59-.82,1-1a7.13,7.13,0,0,1,1.61-.75,6,6,0,0,1,1.9-.07c1.08.09,2.17.23,3.23.32a.2.2,0,0,1,0-.09c-1-.34-2-.77-3.12-1.06a6.3,6.3,0,0,1-3.16-1.61c-.25-.27-.71-.84-.59-1.22s.83-.25,1.13-.18a9.62,9.62,0,0,1,3.55,1.76c.79.55,1.65,1.07,2.42,1.65a.53.53,0,0,1,.09-.11c-.25-.25-.45-.5-.7-.72-.54-.5-1.15-.86-1.7-1.36a7.12,7.12,0,0,1-1.81-2.89c-.09-.32-.25-1.05.18-1.2s1,.31,1.25.52a8,8,0,0,1,2.17,2.89,18.75,18.75,0,0,1,1.06,2.44c-.13-.72-.27-1.42-.36-2.14a7.36,7.36,0,0,1,.36-3.89c.18-.43,1.34-2.36,1.81-1.18a4.83,4.83,0,0,1,.14,1.9,11.13,11.13,0,0,1-.3,2.15c-.22,1.08-.54,2.15-.86,3.21a1.36,1.36,0,0,1,.25.11,31.53,31.53,0,0,1,1.86-2.89,6.13,6.13,0,0,1,2.76-2.22c.34-.13,1-.5,1.35-.16s0,.86-.13,1.16a7.19,7.19,0,0,1-2.76,2.6l-1.83,1.22c-.32.2-.64.38-.93.59a.52.52,0,0,1,.14.2c.09-.07.18-.11.27-.18a11.64,11.64,0,0,1,2.89-1.49,7.64,7.64,0,0,1,1.9-.39,6.63,6.63,0,0,1,2,0,1.32,1.32,0,0,1,1.11.73c.16.47-.25.88-.61,1.11a3,3,0,0,1-1.49.4c-.75.07-1.47.12-2.2.16l-3.71.25a.47.47,0,0,1,0,.23,15.57,15.57,0,0,1,3.48.79,8.68,8.68,0,0,1,3.28,1.88c.25.27.77.74.54,1.15s-1,.32-1.4.23a11.69,11.69,0,0,1-3.57-1.77c-.88-.56-1.74-1.2-2.58-1.83a.3.3,0,0,1-.18.16,11.61,11.61,0,0,1,.86,1.13,18,18,0,0,1,1.47,2.06,11.46,11.46,0,0,1,1.08,3.86c0,.39,0,1-.54.84A3,3,0,0,1,597.08,343.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.58,346.5a8,8,0,0,1-1.43-3.55c-.18-1-.25-2-.47-2.92a1.65,1.65,0,0,1-.3,0c.05.52,0,1,.05,1.54,0,.91.06,1.2,0,2.1a7.56,7.56,0,0,1-1.09,3.83c-.2.31-.54.86-1,.63s-.48-1.2-.5-1.63a9.13,9.13,0,0,1,.43-3.41,9.76,9.76,0,0,1,.88-2.18c.18-.33.38-.67.57-1l-.05,0a22.28,22.28,0,0,1-2.22,3.26,13.79,13.79,0,0,1-1.42,1.44,7.19,7.19,0,0,1-1.4,1.09c-.23.11-.84.47-1,.09s.21-1.18.46-1.61a7.43,7.43,0,0,1,1.13-1.65,12.77,12.77,0,0,1,1.53-1.24,22.59,22.59,0,0,1,2.52-1.74s-.05-.05-.05-.07a31.86,31.86,0,0,1-3.1,1,10.34,10.34,0,0,1-4,.55c-.36-.05-.75-.16-.75-.59s.59-.81,1-1a7.09,7.09,0,0,1,1.61-.74,5.75,5.75,0,0,1,1.9-.07c1.08.09,2.17.22,3.23.31a.2.2,0,0,1,0-.09c-1-.34-2.05-.77-3.12-1.06a6.3,6.3,0,0,1-3.16-1.61c-.25-.27-.7-.83-.59-1.22s.84-.25,1.13-.18a9.64,9.64,0,0,1,3.55,1.77c.79.54,1.65,1.06,2.42,1.65a.62.62,0,0,1,.09-.12c-.25-.24-.45-.49-.7-.72-.54-.5-1.15-.86-1.7-1.36a7.12,7.12,0,0,1-1.81-2.89c-.09-.32-.24-1,.19-1.2s1,.32,1.24.52a8,8,0,0,1,2.17,2.89,18.87,18.87,0,0,1,1.06,2.45c-.13-.73-.27-1.43-.36-2.15a7.36,7.36,0,0,1,.36-3.89c.18-.43,1.34-2.35,1.81-1.18a4.84,4.84,0,0,1,.14,1.9,11,11,0,0,1-.3,2.15c-.22,1.09-.54,2.15-.85,3.21a1.34,1.34,0,0,1,.24.12,30.37,30.37,0,0,1,1.86-2.9,6.13,6.13,0,0,1,2.76-2.22c.34-.13,1-.49,1.36-.15s0,.86-.14,1.15a7.12,7.12,0,0,1-2.76,2.6l-1.83,1.22c-.32.21-.64.39-.93.59a.73.73,0,0,1,.14.2l.27-.18a11.64,11.64,0,0,1,2.89-1.49,7.63,7.63,0,0,1,1.9-.38,6.32,6.32,0,0,1,2,0c.43.07,1,.27,1.11.72s-.25.88-.61,1.11a3.17,3.17,0,0,1-1.49.41c-.75.07-1.47.11-2.2.16l-3.71.24a.47.47,0,0,1,0,.23A16.76,16.76,0,0,1,446,340a8.81,8.81,0,0,1,3.28,1.88c.25.27.77.75.55,1.15s-1,.32-1.41.23a11.25,11.25,0,0,1-3.57-1.77c-.88-.56-1.74-1.19-2.58-1.83a.28.28,0,0,1-.18.16,13,13,0,0,1,.86,1.13,19,19,0,0,1,1.47,2.06,11.59,11.59,0,0,1,1.09,3.87c0,.38,0,1-.55.83A2.93,2.93,0,0,1,443.58,346.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.56,368.09a8.08,8.08,0,0,1-1.43-3.55c-.18-1-.25-2-.47-2.91a1.54,1.54,0,0,1-.3,0c.05.52,0,1,.05,1.54,0,.9.07,1.2,0,2.1a7.49,7.49,0,0,1-1.08,3.82c-.21.32-.55.86-1,.64s-.48-1.2-.5-1.63a9.2,9.2,0,0,1,.43-3.42,9.69,9.69,0,0,1,.88-2.17c.18-.34.39-.68.57-1l0,0a21.6,21.6,0,0,1-2.21,3.25,14,14,0,0,1-1.43,1.45,7.6,7.6,0,0,1-1.4,1.09c-.23.11-.84.47-1,.09s.2-1.18.45-1.61a7.9,7.9,0,0,1,1.13-1.65,12.86,12.86,0,0,1,1.54-1.24,22.47,22.47,0,0,1,2.51-1.74s0-.05,0-.07a31,31,0,0,1-3.1,1,10.68,10.68,0,0,1-4,.55c-.36-.05-.75-.16-.75-.59s.59-.82.95-1a7.83,7.83,0,0,1,1.61-.75,5.76,5.76,0,0,1,1.9-.06c1.09.09,2.17.22,3.23.31a.15.15,0,0,1,0-.09c-1-.34-2.06-.77-3.12-1.06a6.37,6.37,0,0,1-3.17-1.61c-.25-.27-.7-.83-.59-1.22s.84-.25,1.13-.18a9.77,9.77,0,0,1,3.55,1.76c.8.55,1.65,1.07,2.42,1.66l.09-.12c-.24-.25-.45-.5-.7-.72-.54-.5-1.15-.86-1.69-1.36a7,7,0,0,1-1.81-2.89c-.09-.32-.25-1,.18-1.2s1,.31,1.24.52a8,8,0,0,1,2.17,2.89,19.74,19.74,0,0,1,1.07,2.45c-.14-.73-.27-1.43-.37-2.15a7.37,7.37,0,0,1,.37-3.89c.18-.43,1.33-2.36,1.81-1.18a5,5,0,0,1,.13,1.9,11.12,11.12,0,0,1-.29,2.15c-.23,1.09-.55,2.15-.86,3.21a1.36,1.36,0,0,1,.25.11,29.44,29.44,0,0,1,1.85-2.89,6.24,6.24,0,0,1,2.76-2.22c.34-.13,1-.5,1.36-.16s0,.86-.14,1.16a7.06,7.06,0,0,1-2.76,2.6l-1.83,1.22c-.32.2-.63.38-.93.59a.49.49,0,0,1,.14.2l.27-.18a11.88,11.88,0,0,1,2.9-1.49,7.55,7.55,0,0,1,1.9-.39,6.63,6.63,0,0,1,2,0c.43.06,1,.27,1.1.72s-.24.88-.61,1.11a3.17,3.17,0,0,1-1.49.41l-2.19.15-3.71.25a.39.39,0,0,1,0,.23,16.23,16.23,0,0,1,3.49.79,9,9,0,0,1,3.28,1.88c.24.27.76.74.54,1.15s-1,.32-1.4.23a11.51,11.51,0,0,1-3.58-1.77c-.88-.56-1.74-1.2-2.58-1.83a.28.28,0,0,1-.18.16,13,13,0,0,1,.86,1.13,16.87,16.87,0,0,1,1.47,2.06,11.46,11.46,0,0,1,1.09,3.87c0,.38,0,1-.54.83A3,3,0,0,1,491.56,368.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.18,284.41a8,8,0,0,1-1.42-3.55c-.18-1-.25-2-.48-2.92a1.47,1.47,0,0,1-.29.05c0,.52,0,1,0,1.53,0,.91.07,1.2,0,2.11a7.55,7.55,0,0,1-1.09,3.82c-.2.32-.54.86-1,.63s-.47-1.2-.49-1.63a9.12,9.12,0,0,1,.42-3.41,9.53,9.53,0,0,1,.89-2.17c.18-.34.38-.68.56-1l0-.05a21.75,21.75,0,0,1-2.22,3.26,16.2,16.2,0,0,1-1.42,1.45,7.31,7.31,0,0,1-1.41,1.08c-.22.11-.83.48-1,.09s.2-1.17.45-1.6a7.65,7.65,0,0,1,1.13-1.65,13.81,13.81,0,0,1,1.54-1.25,25,25,0,0,1,2.51-1.74.13.13,0,0,1,0-.07,29.41,29.41,0,0,1-3.1,1,10.53,10.53,0,0,1-4,.54c-.37-.05-.75-.16-.75-.59s.59-.81.95-1a7.71,7.71,0,0,1,1.6-.74,5.77,5.77,0,0,1,1.9-.07c1.09.09,2.18.23,3.24.32a.16.16,0,0,1,0-.09c-1-.34-2.06-.77-3.12-1.07a6.35,6.35,0,0,1-3.17-1.6c-.24-.27-.7-.84-.58-1.22s.83-.25,1.13-.19a9.87,9.87,0,0,1,3.55,1.77c.79.54,1.65,1.06,2.42,1.65a.35.35,0,0,1,.09-.11c-.25-.25-.45-.5-.7-.73-.55-.49-1.16-.86-1.7-1.35a7.16,7.16,0,0,1-1.81-2.9c-.09-.32-.25-1,.18-1.2s1,.32,1.25.52a8.2,8.2,0,0,1,2.17,2.9,19.55,19.55,0,0,1,1.06,2.44c-.13-.72-.27-1.42-.36-2.15a7.36,7.36,0,0,1,.36-3.89c.18-.43,1.34-2.35,1.81-1.18a4.86,4.86,0,0,1,.14,1.9,11.84,11.84,0,0,1-.3,2.15c-.22,1.09-.54,2.15-.86,3.22a.91.91,0,0,1,.25.11,30.37,30.37,0,0,1,1.86-2.9,6.11,6.11,0,0,1,2.76-2.21c.33-.14,1-.5,1.35-.16s0,.86-.13,1.15a7.12,7.12,0,0,1-2.76,2.6l-1.83,1.22c-.32.21-.64.39-.93.59a.48.48,0,0,1,.13.21l.27-.19a11.88,11.88,0,0,1,2.9-1.49,7.54,7.54,0,0,1,1.9-.38,6.32,6.32,0,0,1,2,0c.43.07,1,.27,1.11.72s-.25.89-.61,1.11a3.05,3.05,0,0,1-1.49.41c-.75.07-1.47.11-2.2.16l-3.71.25a.45.45,0,0,1,0,.22,16.76,16.76,0,0,1,3.48.79,8.89,8.89,0,0,1,3.28,1.88c.25.27.77.75.54,1.16s-1,.31-1.4.22a11.33,11.33,0,0,1-3.57-1.76c-.89-.57-1.75-1.2-2.58-1.83a.31.31,0,0,1-.18.15c.31.37.58.75.86,1.13A19,19,0,0,1,448,280.9a11.58,11.58,0,0,1,1.08,3.87c.05.38,0,1-.54.84A3,3,0,0,1,447.18,284.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.19,342.33a8,8,0,0,1-1.42-3.56c-.19-1-.25-2-.48-2.91a1.45,1.45,0,0,1-.29,0c0,.52,0,1,0,1.54,0,.9.07,1.2,0,2.1a7.55,7.55,0,0,1-1.08,3.83c-.2.31-.54.86-1,.63s-.47-1.2-.5-1.63a9.42,9.42,0,0,1,.43-3.42,9.72,9.72,0,0,1,.89-2.17c.18-.34.38-.67.56-1l0,0a21.66,21.66,0,0,1-2.22,3.25,13.06,13.06,0,0,1-1.43,1.45,7.6,7.6,0,0,1-1.4,1.09c-.22.11-.84.47-1,.09s.2-1.18.45-1.61a7.9,7.9,0,0,1,1.13-1.65,13.71,13.71,0,0,1,1.54-1.24,22.47,22.47,0,0,1,2.51-1.74s0,0,0-.07a31.86,31.86,0,0,1-3.1,1,10.56,10.56,0,0,1-4,.55c-.36-.05-.74-.16-.74-.59s.59-.82,1-1a7.75,7.75,0,0,1,1.6-.75,6,6,0,0,1,1.9-.06c1.09.09,2.17.22,3.24.31a.2.2,0,0,1,0-.09c-1-.34-2.06-.77-3.12-1.06a6.37,6.37,0,0,1-3.17-1.61c-.25-.27-.7-.83-.59-1.22s.84-.25,1.13-.18a9.76,9.76,0,0,1,3.56,1.77c.79.54,1.65,1.06,2.42,1.65a.38.38,0,0,1,.09-.12c-.25-.25-.46-.49-.7-.72-.55-.5-1.16-.86-1.7-1.36a7,7,0,0,1-1.81-2.89c-.09-.32-.25-1,.18-1.2s1,.32,1.24.52a8.07,8.07,0,0,1,2.18,2.89,22.08,22.08,0,0,1,1.06,2.45c-.14-.73-.27-1.43-.36-2.15a7.36,7.36,0,0,1,.36-3.89c.18-.43,1.33-2.35,1.81-1.18a4.83,4.83,0,0,1,.13,1.9,11,11,0,0,1-.29,2.15c-.23,1.09-.54,2.15-.86,3.21a1.36,1.36,0,0,1,.25.11,31.42,31.42,0,0,1,1.85-2.89,6.24,6.24,0,0,1,2.76-2.22c.34-.13,1-.49,1.36-.15s0,.85-.14,1.15a7.1,7.1,0,0,1-2.75,2.6l-1.84,1.22c-.31.2-.63.39-.92.59a.57.57,0,0,1,.13.2l.27-.18a11.88,11.88,0,0,1,2.9-1.49,8,8,0,0,1,1.9-.39,6.63,6.63,0,0,1,2,0,1.29,1.29,0,0,1,1.11.72c.16.48-.25.88-.61,1.11a3.21,3.21,0,0,1-1.5.41l-2.19.15c-1.24.1-2.47.16-3.71.25a.39.39,0,0,1,0,.23,16.85,16.85,0,0,1,3.49.79,9,9,0,0,1,3.28,1.88c.25.27.77.74.54,1.15s-1,.32-1.4.23a11.3,11.3,0,0,1-3.58-1.77c-.88-.56-1.74-1.19-2.57-1.83a.33.33,0,0,1-.18.16c.31.36.58.75.85,1.13a17.68,17.68,0,0,1,1.47,2.06,11.36,11.36,0,0,1,1.09,3.87c.05.38,0,1-.54.83A3,3,0,0,1,345.19,342.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,307.78a10.82,10.82,0,0,1-4.2-3c-.91-1-1.71-2.06-2.65-3a2,2,0,0,1-.31.27c.43.56.77,1.14,1.17,1.72.66,1,.95,1.32,1.55,2.38a10.15,10.15,0,0,1,1.53,5.15c0,.51,0,1.37-.7,1.46s-1.41-1-1.75-1.5a12.32,12.32,0,0,1-2-4.21,12.55,12.55,0,0,1-.57-3.11c0-.52-.05-1.06-.11-1.6l-.08,0a30.38,30.38,0,0,1-.17,5.32,19,19,0,0,1-.58,2.69,9.81,9.81,0,0,1-.81,2.25c-.17.3-.61,1.15-1,.81-.6-.42-.62-1.49-.65-2.16a10.14,10.14,0,0,1,.09-2.7,18.92,18.92,0,0,1,.85-2.54,32.54,32.54,0,0,1,1.61-3.8.16.16,0,0,1-.11-.05,41.75,41.75,0,0,1-2.81,3.39,14.36,14.36,0,0,1-4.17,3.52c-.45.21-1,.36-1.28-.13s.08-1.36.35-1.85a10.06,10.06,0,0,1,1.29-2,7.82,7.82,0,0,1,2.12-1.45c1.3-.69,2.64-1.32,3.91-2a.31.31,0,0,1,0-.12c-1.43.37-2.9.62-4.33,1.05a8.54,8.54,0,0,1-4.77.47c-.48-.13-1.41-.45-1.56-1s.77-.89,1.16-1a13.3,13.3,0,0,1,5.33-.56c1.3.05,2.65,0,4,.13a.53.53,0,0,1,0-.19c-.47-.11-.88-.24-1.33-.32-1-.17-1.94-.14-2.92-.32a9.57,9.57,0,0,1-4.16-2c-.33-.29-1-1-.66-1.5s1.34-.34,1.79-.31a10.89,10.89,0,0,1,4.58,1.73,26.42,26.42,0,0,1,3,2c-.68-.73-1.34-1.43-2-2.19a9.92,9.92,0,0,1-2.4-4.7c-.11-.62-.19-3.65,1.21-2.65a6.56,6.56,0,0,1,1.53,2.06,15.67,15.67,0,0,1,1.22,2.67c.53,1.4.94,2.84,1.35,4.29a2,2,0,0,1,.37-.06,39.91,39.91,0,0,1,0-4.64A8.35,8.35,0,0,1,310,290c.29-.4.8-1.31,1.44-1.17s.64,1,.68,1.42c.21,1.75-.56,3.39-1.26,5l-1.21,2.73c-.21.46-.44.89-.63,1.34a.7.7,0,0,1,.3.13c.06-.14.13-.26.18-.4a15.89,15.89,0,0,1,2.22-3.8,10.2,10.2,0,0,1,1.89-1.82,9.11,9.11,0,0,1,2.29-1.42,1.76,1.76,0,0,1,1.79,0c.52.42.35,1.18.1,1.7a4,4,0,0,1-1.41,1.55c-.8.62-1.59,1.2-2.38,1.77-1.36,1-2.7,2-4,3a.54.54,0,0,1,.11.29,21.71,21.71,0,0,1,4.55-1.63,12,12,0,0,1,5.1-.23c.48.13,1.42.29,1.45.92s-.9,1.08-1.43,1.27a15.3,15.3,0,0,1-5.36.58c-1.41,0-2.85-.1-4.27-.22a.38.38,0,0,1-.09.31c.62.19,1.21.43,1.8.67a24.69,24.69,0,0,1,3.17,1.28,15.54,15.54,0,0,1,4,3.63c.33.4.77,1.14,0,1.35A4.1,4.1,0,0,1,316.55,307.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,262.59a10.77,10.77,0,0,1-4.2-3c-.92-1-1.72-2.06-2.66-3a1.8,1.8,0,0,1-.3.26c.42.56.76,1.15,1.16,1.72.66,1,1,1.32,1.55,2.39a10.19,10.19,0,0,1,1.54,5.14c0,.51,0,1.38-.71,1.46s-1.41-1-1.74-1.49a12.43,12.43,0,0,1-2-4.21,12.71,12.71,0,0,1-.57-3.12c0-.52-.05-1.05-.11-1.59l-.08,0a29.44,29.44,0,0,1-.17,5.32,20.27,20.27,0,0,1-.57,2.68,10.42,10.42,0,0,1-.82,2.26c-.17.29-.61,1.15-1,.81-.59-.42-.62-1.49-.65-2.16a10.66,10.66,0,0,1,.09-2.71,17.93,17.93,0,0,1,.86-2.53,30.36,30.36,0,0,1,1.6-3.81s-.09,0-.1,0a42.06,42.06,0,0,1-2.82,3.38,14.06,14.06,0,0,1-4.17,3.52c-.45.21-1,.36-1.28-.13s.08-1.35.35-1.85a10,10,0,0,1,1.29-2,7.85,7.85,0,0,1,2.12-1.46c1.3-.68,2.64-1.31,3.92-2a.17.17,0,0,1,0-.12c-1.44.37-2.91.61-4.34,1.05a8.52,8.52,0,0,1-4.77.46c-.48-.13-1.41-.44-1.56-1s.78-.89,1.16-1a13.14,13.14,0,0,1,5.33-.56c1.3,0,2.65,0,4,.13a.59.59,0,0,1,0-.2c-.46-.1-.88-.24-1.33-.32-1-.17-1.93-.14-2.91-.31a9.67,9.67,0,0,1-4.17-2c-.33-.3-1-1-.66-1.5s1.34-.35,1.8-.31a10.9,10.9,0,0,1,4.57,1.73,26,26,0,0,1,3,2c-.68-.72-1.35-1.43-2-2.19a9.81,9.81,0,0,1-2.41-4.7c-.11-.62-.19-3.65,1.21-2.65a6.6,6.6,0,0,1,1.53,2.07,14.84,14.84,0,0,1,1.22,2.66c.53,1.41.94,2.85,1.35,4.29a1.44,1.44,0,0,1,.37,0,40.08,40.08,0,0,1,0-4.65,8.38,8.38,0,0,1,1.54-4.53c.29-.4.8-1.3,1.44-1.16s.65,1,.68,1.41c.21,1.75-.56,3.4-1.26,5l-1.21,2.72c-.21.46-.44.9-.63,1.34a.7.7,0,0,1,.3.14c.06-.14.13-.26.18-.4a15.76,15.76,0,0,1,2.22-3.81,10.46,10.46,0,0,1,1.89-1.81,8.57,8.57,0,0,1,2.29-1.42,1.76,1.76,0,0,1,1.79,0c.52.43.35,1.19.1,1.71a4.08,4.08,0,0,1-1.4,1.55c-.81.61-1.6,1.19-2.39,1.77l-4.05,3a.57.57,0,0,1,.11.29,21.87,21.87,0,0,1,4.55-1.62,11.86,11.86,0,0,1,5.1-.24c.48.13,1.42.3,1.45.92s-.9,1.09-1.43,1.28a15.54,15.54,0,0,1-5.36.58c-1.41,0-2.85-.11-4.27-.22a.4.4,0,0,1-.09.31,15.47,15.47,0,0,1,1.8.67A23.32,23.32,0,0,1,386,258a15.52,15.52,0,0,1,4.05,3.62c.33.41.76,1.15,0,1.35A4,4,0,0,1,387.65,262.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.23,315.54a10.92,10.92,0,0,1-4.2-3c-.91-1-1.71-2.06-2.66-3a1.25,1.25,0,0,1-.3.26c.43.56.77,1.15,1.17,1.72.65,1,.95,1.32,1.55,2.39a10.14,10.14,0,0,1,1.53,5.14c0,.51,0,1.38-.7,1.46s-1.41-1-1.75-1.49a12.41,12.41,0,0,1-2-4.21,12.63,12.63,0,0,1-.57-3.12c0-.51-.06-1.05-.11-1.59l-.09,0a29.44,29.44,0,0,1-.16,5.32,20.44,20.44,0,0,1-.58,2.69,9.81,9.81,0,0,1-.81,2.25c-.18.29-.61,1.15-1,.81-.6-.42-.62-1.49-.65-2.16a10.14,10.14,0,0,1,.09-2.7,18.92,18.92,0,0,1,.85-2.54,33.66,33.66,0,0,1,1.6-3.81.12.12,0,0,1-.1,0,40,40,0,0,1-2.81,3.38,14.18,14.18,0,0,1-4.17,3.52c-.45.21-1,.36-1.28-.13s.08-1.35.34-1.85a10,10,0,0,1,1.3-2,8.2,8.2,0,0,1,2.11-1.46c1.31-.68,2.64-1.31,3.92-2a.4.4,0,0,1,0-.12c-1.43.37-2.9.62-4.33,1.05a8.47,8.47,0,0,1-4.78.46c-.48-.12-1.4-.44-1.55-1s.77-.89,1.16-1a13.12,13.12,0,0,1,5.33-.56c1.29,0,2.65,0,4,.13a1.06,1.06,0,0,1,0-.2c-.47-.1-.88-.24-1.33-.31-1-.18-1.94-.15-2.92-.32a9.52,9.52,0,0,1-4.16-2c-.33-.3-1-1-.66-1.5s1.34-.34,1.79-.31a10.89,10.89,0,0,1,4.58,1.73,26.34,26.34,0,0,1,3,2c-.68-.72-1.34-1.42-2-2.18a10.08,10.08,0,0,1-2.41-4.7c-.1-.63-.18-3.66,1.21-2.66a6.48,6.48,0,0,1,1.54,2.07,15.32,15.32,0,0,1,1.22,2.67c.53,1.4.94,2.84,1.35,4.28a1.42,1.42,0,0,1,.36-.05,42.44,42.44,0,0,1,0-4.65,8.38,8.38,0,0,1,1.54-4.53c.29-.4.8-1.3,1.43-1.16s.65,1,.69,1.41a9.62,9.62,0,0,1-1.27,5l-1.2,2.72c-.21.46-.44.9-.63,1.35a.6.6,0,0,1,.3.13c.05-.14.13-.26.18-.4a16,16,0,0,1,2.22-3.81,10.48,10.48,0,0,1,1.89-1.81,9.05,9.05,0,0,1,2.28-1.42,1.79,1.79,0,0,1,1.79,0c.53.43.36,1.19.11,1.71A4.19,4.19,0,0,1,406,303c-.8.62-1.59,1.19-2.38,1.77l-4.06,3a.58.58,0,0,1,.12.29,22.38,22.38,0,0,1,4.54-1.62,11.91,11.91,0,0,1,5.11-.24c.48.13,1.41.3,1.45.93s-.9,1.08-1.43,1.27a15.57,15.57,0,0,1-5.36.58c-1.42,0-2.86-.11-4.27-.22a.41.41,0,0,1-.09.31,18.45,18.45,0,0,1,1.8.67,23.85,23.85,0,0,1,3.17,1.28,15.68,15.68,0,0,1,4,3.62c.33.41.77,1.15,0,1.35A4.09,4.09,0,0,1,406.23,315.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.9,314.59a10.82,10.82,0,0,1-4.2-3c-.91-1-1.71-2.06-2.65-3a1.53,1.53,0,0,1-.31.26c.43.57.77,1.15,1.17,1.73.66,1,.95,1.31,1.55,2.38a10.15,10.15,0,0,1,1.53,5.15c0,.51,0,1.37-.7,1.46s-1.41-1-1.75-1.5a12.32,12.32,0,0,1-2-4.21,12.55,12.55,0,0,1-.57-3.11c0-.52-.05-1.06-.11-1.6l-.08,0a30.38,30.38,0,0,1-.17,5.32,19,19,0,0,1-.58,2.69,9.81,9.81,0,0,1-.81,2.25c-.17.3-.61,1.15-1,.81-.6-.42-.62-1.49-.65-2.16a10.14,10.14,0,0,1,.09-2.7,18.92,18.92,0,0,1,.85-2.54,31.83,31.83,0,0,1,1.61-3.8A.16.16,0,0,1,484,309a40,40,0,0,1-2.81,3.38,14.24,14.24,0,0,1-4.17,3.53c-.45.21-1,.36-1.28-.13s.08-1.36.35-1.85a9.79,9.79,0,0,1,1.29-2,7.92,7.92,0,0,1,2.11-1.45c1.31-.69,2.65-1.32,3.92-2a.31.31,0,0,1,0-.12c-1.43.37-2.9.62-4.33,1.05a8.54,8.54,0,0,1-4.77.47c-.48-.13-1.41-.45-1.56-1s.77-.89,1.16-1a13.12,13.12,0,0,1,5.33-.56c1.3.05,2.65,0,4,.13a.53.53,0,0,1,0-.19c-.47-.11-.88-.24-1.33-.32-1-.18-1.94-.15-2.92-.32a9.52,9.52,0,0,1-4.16-2c-.33-.3-1-1-.66-1.5s1.34-.34,1.79-.31a10.89,10.89,0,0,1,4.58,1.73,26.42,26.42,0,0,1,3,2c-.68-.73-1.34-1.43-2-2.19a10,10,0,0,1-2.4-4.7c-.11-.62-.19-3.65,1.21-2.66a6.72,6.72,0,0,1,1.53,2.07A15.67,15.67,0,0,1,483,301.7c.53,1.4.94,2.84,1.35,4.28a2.07,2.07,0,0,1,.37-.05,39.91,39.91,0,0,1,0-4.64,8.33,8.33,0,0,1,1.54-4.53c.29-.4.8-1.31,1.44-1.17s.64,1,.68,1.42c.21,1.75-.56,3.39-1.26,5L486,304.7c-.21.46-.44.89-.63,1.34a.7.7,0,0,1,.3.13c.06-.14.13-.26.18-.4A15.89,15.89,0,0,1,488,302a10.2,10.2,0,0,1,1.89-1.82,9.11,9.11,0,0,1,2.29-1.42,1.76,1.76,0,0,1,1.79,0c.52.42.35,1.18.1,1.7a4.19,4.19,0,0,1-1.41,1.55c-.8.62-1.59,1.19-2.38,1.77-1.36,1-2.7,2-4.05,3a.67.67,0,0,1,.11.3,21.71,21.71,0,0,1,4.55-1.63,11.86,11.86,0,0,1,5.1-.23c.48.13,1.42.29,1.45.92s-.9,1.08-1.43,1.27a15.54,15.54,0,0,1-5.36.58c-1.41,0-2.85-.1-4.27-.22a.38.38,0,0,1-.09.31c.62.19,1.21.43,1.8.67a24.69,24.69,0,0,1,3.17,1.28,15.54,15.54,0,0,1,4,3.63c.33.4.77,1.14,0,1.34A4.09,4.09,0,0,1,492.9,314.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,370.39a10.82,10.82,0,0,1-4.2-3c-.91-1-1.71-2.06-2.65-3a2,2,0,0,1-.31.27c.43.56.77,1.14,1.17,1.72.66,1,.95,1.31,1.55,2.38a10.15,10.15,0,0,1,1.53,5.15c0,.51,0,1.37-.7,1.46s-1.41-1-1.75-1.5a12.32,12.32,0,0,1-2-4.21,12.55,12.55,0,0,1-.57-3.11c0-.52-.05-1.06-.11-1.6l-.08,0a30.38,30.38,0,0,1-.17,5.32,19,19,0,0,1-.58,2.69,9.81,9.81,0,0,1-.81,2.25c-.18.3-.61,1.15-1,.81-.6-.42-.62-1.49-.65-2.16a10.14,10.14,0,0,1,.09-2.7,18.92,18.92,0,0,1,.85-2.54,33.5,33.5,0,0,1,1.6-3.8.16.16,0,0,1-.1-.05,40,40,0,0,1-2.81,3.38,14.37,14.37,0,0,1-4.17,3.53c-.45.21-1,.36-1.28-.13s.08-1.36.35-1.85a9.79,9.79,0,0,1,1.29-2,7.92,7.92,0,0,1,2.11-1.45c1.31-.69,2.65-1.32,3.92-2a.31.31,0,0,1,0-.12c-1.43.37-2.9.62-4.33,1a8.54,8.54,0,0,1-4.77.47c-.48-.13-1.41-.45-1.56-1s.77-.89,1.16-1a13.12,13.12,0,0,1,5.33-.56c1.29.05,2.65,0,4,.13a.53.53,0,0,1,0-.19c-.47-.11-.88-.24-1.33-.32-1-.18-1.94-.15-2.92-.32a9.52,9.52,0,0,1-4.16-2c-.33-.3-1-1-.66-1.5s1.34-.34,1.79-.31a10.89,10.89,0,0,1,4.58,1.73,26.42,26.42,0,0,1,3,2c-.68-.73-1.34-1.43-2-2.19a10,10,0,0,1-2.4-4.7c-.11-.62-.19-3.65,1.21-2.66a6.72,6.72,0,0,1,1.53,2.07,15.67,15.67,0,0,1,1.22,2.67c.53,1.4.94,2.84,1.35,4.28a2.07,2.07,0,0,1,.37,0,39.91,39.91,0,0,1,0-4.64,8.33,8.33,0,0,1,1.54-4.53c.29-.4.8-1.31,1.44-1.17s.64,1,.68,1.42a9.7,9.7,0,0,1-1.26,5c-.41.91-.81,1.82-1.21,2.73-.21.46-.44.89-.63,1.34a.7.7,0,0,1,.3.13c.06-.14.13-.26.18-.4a15.89,15.89,0,0,1,2.22-3.8A10.2,10.2,0,0,1,385,356a8.93,8.93,0,0,1,2.29-1.42,1.74,1.74,0,0,1,1.78,0c.53.42.36,1.18.11,1.7a4.19,4.19,0,0,1-1.41,1.55c-.8.62-1.59,1.19-2.38,1.77-1.36,1-2.7,2-4.05,3a.72.72,0,0,1,.11.3,21.71,21.71,0,0,1,4.55-1.63,11.86,11.86,0,0,1,5.1-.23c.48.13,1.42.29,1.45.92s-.9,1.08-1.43,1.27a15.54,15.54,0,0,1-5.36.58c-1.41,0-2.85-.1-4.27-.22a.38.38,0,0,1-.09.31c.62.19,1.21.43,1.8.67a24.69,24.69,0,0,1,3.17,1.28,15.54,15.54,0,0,1,4,3.63c.33.4.77,1.14,0,1.34A4.09,4.09,0,0,1,388,370.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.35,363.61a10.82,10.82,0,0,1-4.2-3c-.91-1-1.71-2.06-2.66-3a2.52,2.52,0,0,1-.3.27c.43.56.76,1.14,1.17,1.72.65,1,.94,1.31,1.55,2.38a10.24,10.24,0,0,1,1.53,5.15c0,.51,0,1.37-.7,1.46s-1.41-1-1.75-1.5a12.35,12.35,0,0,1-2-4.21,13,13,0,0,1-.57-3.11c0-.52,0-1.06-.1-1.6l-.09,0a28.56,28.56,0,0,1-.17,5.32,18.92,18.92,0,0,1-.57,2.69,10.31,10.31,0,0,1-.81,2.25c-.18.3-.61,1.15-1.05.81s-.62-1.49-.65-2.16a10.14,10.14,0,0,1,.1-2.7,16.46,16.46,0,0,1,.85-2.54,30.22,30.22,0,0,1,1.6-3.8.16.16,0,0,1-.1,0,40,40,0,0,1-2.81,3.38,14.28,14.28,0,0,1-4.18,3.53c-.44.21-1,.36-1.27-.13s.08-1.36.34-1.85a9.79,9.79,0,0,1,1.29-2,7.82,7.82,0,0,1,2.12-1.45c1.3-.69,2.64-1.32,3.92-2,0,0,0-.05,0-.12-1.43.37-2.91.62-4.33,1.05a8.56,8.56,0,0,1-4.78.47c-.48-.13-1.41-.45-1.56-1s.78-.89,1.16-1a13.16,13.16,0,0,1,5.33-.56c1.3.05,2.66,0,4,.13a.53.53,0,0,1,0-.19c-.46-.11-.87-.24-1.32-.32-1-.18-1.94-.15-2.92-.32a9.52,9.52,0,0,1-4.16-2c-.34-.3-1-1-.67-1.5s1.34-.34,1.8-.31a10.94,10.94,0,0,1,4.58,1.73,27.35,27.35,0,0,1,3,2c-.68-.73-1.34-1.43-2-2.19a10,10,0,0,1-2.41-4.7c-.11-.62-.18-3.65,1.21-2.66a6.72,6.72,0,0,1,1.53,2.07,15.72,15.72,0,0,1,1.23,2.67c.53,1.4.93,2.84,1.34,4.28a2.07,2.07,0,0,1,.37-.05,39.91,39.91,0,0,1,0-4.64,8.25,8.25,0,0,1,1.54-4.53c.29-.4.8-1.31,1.43-1.17s.65,1,.68,1.42c.21,1.75-.56,3.39-1.26,5l-1.2,2.73c-.22.46-.45.89-.64,1.34a.81.81,0,0,1,.31.13c0-.14.12-.26.18-.4a15.26,15.26,0,0,1,2.22-3.8,10.14,10.14,0,0,1,1.88-1.82,9.11,9.11,0,0,1,2.29-1.42,1.76,1.76,0,0,1,1.79,0c.52.42.36,1.18.11,1.7a4.19,4.19,0,0,1-1.41,1.55c-.8.62-1.6,1.19-2.39,1.77-1.35,1-2.7,2-4,3a.52.52,0,0,1,.11.3,22.12,22.12,0,0,1,4.55-1.63,11.87,11.87,0,0,1,5.1-.23c.48.13,1.42.29,1.46.92s-.91,1.08-1.44,1.27a15.51,15.51,0,0,1-5.35.58c-1.42,0-2.86-.1-4.27-.22a.41.41,0,0,1-.09.31c.62.19,1.21.43,1.8.67a25.29,25.29,0,0,1,3.17,1.28,15.7,15.7,0,0,1,4,3.63c.33.4.76,1.14,0,1.34A4.08,4.08,0,0,1,555.35,363.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.43,306.27a10.84,10.84,0,0,1-4.2-3c-.91-1-1.71-2.06-2.66-3a1.8,1.8,0,0,1-.3.26c.43.56.76,1.15,1.16,1.72.66,1,1,1.32,1.56,2.39a10.31,10.31,0,0,1,1.53,5.14c0,.51,0,1.38-.7,1.46s-1.41-1-1.75-1.49a12.43,12.43,0,0,1-2-4.21,13.11,13.11,0,0,1-.57-3.12c0-.51,0-1.05-.11-1.59l-.08,0a28.56,28.56,0,0,1-.17,5.32,18.5,18.5,0,0,1-.57,2.68,10.38,10.38,0,0,1-.81,2.26c-.18.29-.61,1.15-1,.81-.59-.42-.62-1.49-.65-2.16a10.13,10.13,0,0,1,.1-2.7,16.46,16.46,0,0,1,.85-2.54,30.36,30.36,0,0,1,1.6-3.81s-.08,0-.1,0a40,40,0,0,1-2.81,3.38,14.09,14.09,0,0,1-4.18,3.52c-.44.21-1,.36-1.28-.13s.09-1.35.35-1.85a10,10,0,0,1,1.29-2,7.85,7.85,0,0,1,2.12-1.46c1.3-.68,2.64-1.31,3.92-2a.24.24,0,0,1,0-.12c-1.43.37-2.91.61-4.33,1a8.47,8.47,0,0,1-4.78.46c-.48-.13-1.41-.44-1.56-1s.78-.89,1.16-1a13.16,13.16,0,0,1,5.33-.56c1.3,0,2.66,0,4,.13a.59.59,0,0,1,0-.2c-.46-.1-.87-.24-1.32-.31-1-.18-1.94-.15-2.92-.32a9.63,9.63,0,0,1-4.16-2c-.34-.3-1-1-.67-1.5s1.34-.35,1.8-.31a10.9,10.9,0,0,1,4.57,1.73,26.46,26.46,0,0,1,3,2c-.68-.72-1.34-1.43-2-2.19a9.91,9.91,0,0,1-2.41-4.69c-.11-.63-.18-3.66,1.21-2.66a6.6,6.6,0,0,1,1.53,2.07,15.62,15.62,0,0,1,1.23,2.66c.52,1.41.93,2.85,1.34,4.29a1.44,1.44,0,0,1,.37-.05,38,38,0,0,1,0-4.65,8.3,8.3,0,0,1,1.54-4.53c.29-.4.8-1.3,1.43-1.16s.65,1,.68,1.41c.21,1.75-.56,3.4-1.26,5l-1.2,2.72c-.22.46-.45.9-.64,1.35a.68.68,0,0,1,.31.13c.05-.14.12-.26.18-.4a15.32,15.32,0,0,1,2.22-3.81,10.42,10.42,0,0,1,1.88-1.81,9.11,9.11,0,0,1,2.29-1.42,1.79,1.79,0,0,1,1.79,0,1.41,1.41,0,0,1,.11,1.71,4.19,4.19,0,0,1-1.41,1.55c-.8.62-1.6,1.19-2.39,1.77l-4.05,3a.57.57,0,0,1,.11.29,22.08,22.08,0,0,1,4.55-1.62,11.87,11.87,0,0,1,5.1-.24c.48.13,1.42.3,1.46.93s-.91,1.08-1.44,1.27a15.51,15.51,0,0,1-5.35.58c-1.42,0-2.86-.11-4.27-.22a.43.43,0,0,1-.09.31,18.45,18.45,0,0,1,1.8.67,23.19,23.19,0,0,1,3.16,1.28,15.36,15.36,0,0,1,4.05,3.62c.33.41.76,1.15,0,1.35A4.08,4.08,0,0,1,590.43,306.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.11,361.06a10.89,10.89,0,0,1-4.2-3c-.91-1-1.71-2.07-2.65-3a2,2,0,0,1-.31.27c.43.56.77,1.14,1.17,1.72.66,1,1,1.32,1.55,2.38a10.15,10.15,0,0,1,1.53,5.15c0,.51,0,1.37-.7,1.46s-1.41-1-1.75-1.5a12.32,12.32,0,0,1-2-4.21,12.55,12.55,0,0,1-.57-3.11c0-.52-.05-1.05-.11-1.6l-.08,0a30.38,30.38,0,0,1-.17,5.32,19,19,0,0,1-.58,2.69,9.65,9.65,0,0,1-.81,2.25c-.17.3-.61,1.15-1,.81-.6-.42-.62-1.49-.65-2.16a10.14,10.14,0,0,1,.09-2.7,18.32,18.32,0,0,1,.85-2.53,32,32,0,0,1,1.61-3.81.16.16,0,0,1-.11-.05,41.75,41.75,0,0,1-2.81,3.39,14.36,14.36,0,0,1-4.17,3.52c-.45.21-1,.36-1.28-.13s.08-1.36.35-1.85a10.06,10.06,0,0,1,1.29-2,8,8,0,0,1,2.12-1.45c1.3-.69,2.64-1.32,3.91-2a.31.31,0,0,1,0-.12c-1.43.37-2.9.62-4.33,1.05a8.54,8.54,0,0,1-4.77.47c-.48-.13-1.41-.45-1.56-1s.77-.89,1.16-1a13.12,13.12,0,0,1,5.33-.57c1.3,0,2.65,0,4,.13a.53.53,0,0,1,0-.19c-.47-.11-.88-.24-1.33-.32-1-.17-1.94-.14-2.92-.32a9.57,9.57,0,0,1-4.16-2c-.33-.29-1-1-.66-1.5s1.34-.34,1.79-.31a10.89,10.89,0,0,1,4.58,1.73,26.42,26.42,0,0,1,3,2c-.68-.73-1.34-1.43-2-2.19a9.92,9.92,0,0,1-2.4-4.7c-.11-.62-.19-3.65,1.21-2.65A6.56,6.56,0,0,1,649,345.5a15.67,15.67,0,0,1,1.22,2.67c.53,1.4.94,2.84,1.35,4.29a2,2,0,0,1,.37-.06,39.91,39.91,0,0,1,0-4.64,8.35,8.35,0,0,1,1.54-4.53c.29-.4.8-1.31,1.44-1.17s.65,1,.68,1.42c.21,1.75-.56,3.39-1.26,5-.41.9-.81,1.81-1.21,2.72-.21.46-.44.89-.63,1.34a.7.7,0,0,1,.3.13c.06-.14.13-.26.18-.4a15.89,15.89,0,0,1,2.22-3.8,10.2,10.2,0,0,1,1.89-1.82,8.79,8.79,0,0,1,2.29-1.41,1.74,1.74,0,0,1,1.79,0c.52.42.35,1.18.1,1.7a4,4,0,0,1-1.41,1.55c-.8.62-1.59,1.2-2.38,1.77-1.36,1-2.7,2-4,3a.54.54,0,0,1,.11.29,21.71,21.71,0,0,1,4.55-1.63,12,12,0,0,1,5.1-.23c.48.13,1.42.29,1.45.92s-.9,1.08-1.43,1.27a15.3,15.3,0,0,1-5.36.58c-1.41,0-2.85-.1-4.27-.22a.38.38,0,0,1-.09.31c.62.19,1.21.43,1.8.67a24.69,24.69,0,0,1,3.17,1.28,15.54,15.54,0,0,1,4,3.63c.33.4.77,1.14,0,1.35A4.1,4.1,0,0,1,660.11,361.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.27,327.75a10.92,10.92,0,0,1-4.2-3c-.91-1-1.71-2.07-2.66-3a1.88,1.88,0,0,1-.3.27c.43.56.76,1.14,1.17,1.72.65,1,.94,1.32,1.55,2.38a10.24,10.24,0,0,1,1.53,5.15c0,.51,0,1.37-.7,1.46s-1.41-1-1.75-1.5a12.39,12.39,0,0,1-2-4.2,13.19,13.19,0,0,1-.56-3.12c0-.52-.06-1-.11-1.6l-.09,0a28.66,28.66,0,0,1-.17,5.33,18.78,18.78,0,0,1-.57,2.68,10.38,10.38,0,0,1-.81,2.26c-.18.29-.61,1.15-1.05.81-.59-.42-.62-1.49-.65-2.16a10.66,10.66,0,0,1,.1-2.71,16.34,16.34,0,0,1,.85-2.53,31.92,31.92,0,0,1,1.6-3.81.23.23,0,0,1-.1,0,43.39,43.39,0,0,1-2.81,3.38,14.24,14.24,0,0,1-4.18,3.52c-.44.21-1,.36-1.27-.13s.08-1.35.34-1.85a10,10,0,0,1,1.29-2,7.85,7.85,0,0,1,2.12-1.46c1.3-.68,2.64-1.32,3.92-2a.28.28,0,0,1,0-.12c-1.43.36-2.91.61-4.33,1.05a8.56,8.56,0,0,1-4.78.46c-.48-.13-1.4-.44-1.55-1s.77-.89,1.15-1a13,13,0,0,1,5.33-.56c1.3,0,2.66,0,4,.12a.55.55,0,0,1,0-.19c-.46-.1-.87-.24-1.32-.32-1-.17-1.94-.14-2.92-.32a9.41,9.41,0,0,1-4.16-2c-.34-.29-1-1-.67-1.49s1.34-.35,1.8-.31a10.94,10.94,0,0,1,4.58,1.73,25.91,25.91,0,0,1,3,2c-.68-.73-1.34-1.43-2-2.19a9.9,9.9,0,0,1-2.41-4.7c-.1-.62-.18-3.65,1.21-2.65a6.49,6.49,0,0,1,1.53,2.07,15.62,15.62,0,0,1,1.23,2.66c.53,1.4.94,2.85,1.35,4.29a1.3,1.3,0,0,1,.36-.05,40.08,40.08,0,0,1,0-4.65,8.27,8.27,0,0,1,1.54-4.53c.29-.4.8-1.31,1.43-1.16s.65,1,.68,1.41a9.54,9.54,0,0,1-1.26,5l-1.2,2.72c-.22.46-.45.9-.63,1.34a.83.83,0,0,1,.3.14c.05-.15.12-.26.18-.41a15.89,15.89,0,0,1,2.22-3.8,10.41,10.41,0,0,1,1.88-1.81,8.57,8.57,0,0,1,2.29-1.42,1.74,1.74,0,0,1,1.79,0c.53.43.36,1.19.11,1.71a4.24,4.24,0,0,1-1.41,1.54c-.8.62-1.6,1.2-2.39,1.77-1.35,1-2.7,2-4,3a.49.49,0,0,1,.11.29,21.51,21.51,0,0,1,4.55-1.62,11.87,11.87,0,0,1,5.1-.24c.48.13,1.42.29,1.46.92s-.91,1.08-1.44,1.28a15.51,15.51,0,0,1-5.35.58c-1.42,0-2.86-.11-4.27-.22a.44.44,0,0,1-.09.31,18.39,18.39,0,0,1,1.8.66,25.33,25.33,0,0,1,3.17,1.29,15.32,15.32,0,0,1,4,3.62c.33.41.76,1.15,0,1.35A4.08,4.08,0,0,1,241.27,327.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.55,375.92s3-54.57,0-56.76c-4.73-3.47-41.92-.48-44.43-1.49s-52.82-32.16-56.9-32.76-6.76.66-7.42.66-1.86-1.2-5-1.14-12.4,3.11-12.4,3.11-76.1-28.49-130-23.29c-1.86.18-26.44-24.64-59.9-25.52s-48,8.47-49.76,8.1-46.71-1.72-51.39-.84S253.56,272,249.79,275s-26.56,21.73-32.86,29.09-12,37.19-13.75,39.89-12.68,30.36-11.78,35.39,24.2-3.49,42.55-3.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,245.73c-4.11,8.35-17.09,34.35-20.78,37.83-4.38,4.16-32,26-33.44,29.37s-6.71,29-7.76,31.89-12.37,32.32-13.92,34.23h0c-9.56,1.77-16.9,3.12-17.4.35-.89-5,10.06-32.7,11.79-35.39s7.44-32.53,13.75-39.89S246,278.08,249.79,275s14.9-28.17,19.58-29.05C271,245.69,277.15,245.64,284.73,245.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.32,354.62c-8,0-28.63-1.47-40.75-2.39a80.37,80.37,0,0,1,3.61-8.21c.57-.89,1.55-4.68,2.86-9.63,9.66,2.51,32.07,11.13,37.64,11.13,6.23,0,64.14-7.79,65-4.2C309.35,343.85,252.07,354.62,240.32,354.62Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,333.17c1.95-3.35,21.52-3.6,26.07-4.32s17.25-3.11,19.16-1.91-10.78,7.18-15.57,7.66S279.6,335.56,281,333.17Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.12,301.35c-.86,1.38-8,.76-9.64.9s-6.39.71-7,.12,4.23-2.73,6-2.76S408.73,300.35,408.12,301.35Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.62,288.53c-.4,1-29.06,5.09-32.65,4-2.87-.85-20.43-9.43-29.68-12.17,3.09-2.56,5.48-4.51,6.5-5.33a9.22,9.22,0,0,0,1.4-1.64c7.48,2.82,26.67,13,29.42,13.74C283.84,288,306,287.52,305.62,288.53Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.81,306.29c-1.19,2.24,23.36,18.4,31.26,19.62s61.09.77,61.63-.8-55.88-4.81-59.83-6.25S401.07,303.91,399.81,306.29Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.35,260c.94,2.1,18.5,4.65,22,3.53s14.87-6,14.12-7.37-15.47,1.36-17.73,1.27S307.36,257.79,308.35,260Z",
    style: {
      fill: "#FFC727"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Nightstand--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.92,
    y: 323.24,
    width: 94.21,
    height: 124.38,
    transform: "translate(284.06 770.86) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.36,
    y: 318.4,
    width: 103.34,
    height: 4.84,
    transform: "translate(284.06 641.64) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.86,
    y: 318.4,
    width: 32.5,
    height: 4.84,
    transform: "translate(148.22 641.64) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.18,
    y: 335.92,
    width: 73.69,
    height: 41.55,
    transform: "translate(284.06 713.38) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,377.59H105.06v-41.8H179Zm-73.69-.25h73.44V336H105.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.95,
    y: 348.01,
    width: 14.39,
    height: 8.27,
    transform: "translate(290.3 704.3) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,355.79H133.57v-7.28h14.65Zm-14.4-.25H148v-6.78H133.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 323.24,
    width: 31.92,
    height: 124.38,
    transform: "translate(157.93 770.86) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,430.08H105.06v-41.8H179Zm-73.69-.25h73.44v-41.3H105.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.95,
    y: 400.5,
    width: 14.39,
    height: 8.27,
    transform: "translate(290.3 809.28) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,408.28H133.57V401h14.65Zm-14.4-.25H148v-6.78H133.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.71,
    y: 315.28,
    width: 41.8,
    height: 3.11,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.51 305.69 123.71 305.69 129.71 315.29 171.51 315.29 177.51 305.69",
    style: {
      fill: "#FFC727",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Analysis--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.57,
    y: 65.62,
    width: 386.33,
    height: 132.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,83.61h-1.48l-.3.79a.34.34,0,0,1-.31.21h-.12a.36.36,0,0,1-.2-.44L304,80.57a.33.33,0,0,1,.32-.21.32.32,0,0,1,.32.21L306,84.16a.36.36,0,0,1-.2.44h-.12a.34.34,0,0,1-.31-.21Zm-.25-.67-.49-1.31-.49,1.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37,82.06l-1,2.36s0,0,0,0h0l0,0h0l0,0a0,0,0,0,0,0,0l-.05,0H309l-.06,0h0l0,0h0l0,0h0l0,0-.44-1-.43,1,0,0h0l0,0h0l0,0-.06,0h0s0,0,0,0h-.2s-.05,0-.06,0h0l0,0h0l0,0h0s0,0,0,0l-1-2.36a.31.31,0,1,1,.58-.24l.71,1.64.43-1a.33.33,0,0,1,.3-.19.32.32,0,0,1,.3.19l.43,1,.72-1.64a.3.3,0,0,1,.41-.18A.31.31,0,0,1,310.37,82.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,83.1v1.19a.32.32,0,0,1-.32.32.33.33,0,0,1-.32-.26,1.35,1.35,0,0,1-.81.26,1.46,1.46,0,0,1-1-.44,1.57,1.57,0,0,1-.41-1.07,1.53,1.53,0,0,1,.41-1.07,1.44,1.44,0,0,1,1-.46,1.36,1.36,0,0,1,.81.27.34.34,0,0,1,.32-.27.33.33,0,0,1,.32.33Zm-.65,0a.91.91,0,0,0-.23-.63.79.79,0,0,0-.57-.25.76.76,0,0,0-.57.25,1,1,0,0,0,0,1.25.75.75,0,0,0,.57.24.78.78,0,0,0,.57-.24A.91.91,0,0,0,313.5,83.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.34,84.28V80.69a.33.33,0,0,1,.33-.34.34.34,0,0,1,.34.34v2.1l1.25-1.25a.36.36,0,0,1,.48,0,.34.34,0,0,1,0,.48l-.92.91.94,1.13a.32.32,0,0,1-.05.47.29.29,0,0,1-.21.08.34.34,0,0,1-.26-.12l-.89-1.08-.34.33v.54a.34.34,0,0,1-.34.33A.33.33,0,0,1,315.34,84.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.38,83.09a1.51,1.51,0,0,1,1.49-1.52A1.45,1.45,0,0,1,321.33,83v.09a.3.3,0,0,1-.32.24h-1.94a.78.78,0,0,0,.21.4.94.94,0,0,0,.59.28,1,1,0,0,0,.63-.16.35.35,0,0,1,.46,0,.28.28,0,0,1,0,.39,1.54,1.54,0,0,1-2.58-1.12Zm.66-.3h1.73a1,1,0,0,0-.9-.64A.85.85,0,0,0,319,82.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,112.72a.33.33,0,0,1,.45,0,2,2,0,0,0,1.16.47,1.34,1.34,0,0,0,.76-.23.55.55,0,0,0,.26-.44.38.38,0,0,0,0-.19.57.57,0,0,0-.19-.19,2.34,2.34,0,0,0-.83-.28h0a3.49,3.49,0,0,1-.79-.24,1.29,1.29,0,0,1-.56-.47.88.88,0,0,1-.14-.5,1.1,1.1,0,0,1,.48-.89,1.8,1.8,0,0,1,1.06-.33,2.38,2.38,0,0,1,1.32.49.31.31,0,0,1-.34.53,1.75,1.75,0,0,0-1-.39,1.14,1.14,0,0,0-.68.2.49.49,0,0,0-.24.39.31.31,0,0,0,.05.17.6.6,0,0,0,.16.16,2.29,2.29,0,0,0,.76.26h0a3.31,3.31,0,0,1,.84.26,1.44,1.44,0,0,1,.61.5,1,1,0,0,1,.15.52,1.2,1.2,0,0,1-.52,1,2,2,0,0,1-1.13.34,2.56,2.56,0,0,1-1.56-.61A.33.33,0,0,1,305,112.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.46,109.52a.34.34,0,0,1,.34.33v3.59a.34.34,0,1,1-.67,0v-3.59A.33.33,0,0,1,309.46,109.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.66,112.26a1.52,1.52,0,0,1,1.49-1.53,1.45,1.45,0,0,1,1.46,1.42v.08a.3.3,0,0,1-.32.25h-1.93a.8.8,0,0,0,.2.4,1,1,0,0,0,.59.27,1,1,0,0,0,.63-.15.35.35,0,0,1,.46,0,.28.28,0,0,1,0,.4,1.56,1.56,0,0,1-1.09.4A1.52,1.52,0,0,1,310.66,112.26Zm.66-.3h1.73a1,1,0,0,0-.9-.65A.87.87,0,0,0,311.32,112Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.37,112.26a1.51,1.51,0,0,1,1.48-1.53,1.46,1.46,0,0,1,1.47,1.42v0s0,0,0,0a.29.29,0,0,1-.31.25h-1.94a.82.82,0,0,0,.21.4,1,1,0,0,0,.58.27,1,1,0,0,0,.63-.15.35.35,0,0,1,.46,0,.28.28,0,0,1,0,.4,1.56,1.56,0,0,1-1.09.4A1.51,1.51,0,0,1,314.37,112.26Zm.66-.3h1.72a1,1,0,0,0-.9-.65A.86.86,0,0,0,315,112Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,114.59v-2.32h0v-1.2a.33.33,0,0,1,.33-.33.33.33,0,0,1,.33.25,1.62,1.62,0,0,1,.83-.25,1.51,1.51,0,0,1,1.47,1.53,1.49,1.49,0,0,1-1.47,1.51,1.4,1.4,0,0,1-.82-.25v1.07a.34.34,0,0,1-.67,0Zm.67-2.33a.81.81,0,0,0,.24.61.75.75,0,0,0,.58.26.78.78,0,0,0,.57-.26.89.89,0,0,0,.24-.61.93.93,0,0,0-.24-.61.77.77,0,0,0-.57-.25.74.74,0,0,0-.58.25A.84.84,0,0,0,319,112.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.57,142.61V139a.33.33,0,0,1,.33-.34h.72a2.13,2.13,0,0,1,0,4.26h-.72A.33.33,0,0,1,306.57,142.61Zm.67-.34h.38a1.46,1.46,0,0,0,0-2.91h-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.66,141.42a1.51,1.51,0,0,1,1.49-1.52,1.44,1.44,0,0,1,1.46,1.41v.09a.3.3,0,0,1-.32.24h-1.93a.76.76,0,0,0,.2.4.94.94,0,0,0,.59.28,1,1,0,0,0,.63-.16.35.35,0,0,1,.46,0,.27.27,0,0,1,0,.39,1.54,1.54,0,0,1-2.58-1.12Zm.66-.3h1.73a1,1,0,0,0-.9-.64A.85.85,0,0,0,311.32,141.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.37,141.42a1.5,1.5,0,0,1,1.48-1.52,1.46,1.46,0,0,1,1.47,1.41v0a.15.15,0,0,1,0,.06.29.29,0,0,1-.31.24h-1.94a.78.78,0,0,0,.21.4.91.91,0,0,0,.58.28,1,1,0,0,0,.63-.16.35.35,0,0,1,.46,0,.27.27,0,0,1,0,.39,1.52,1.52,0,0,1-1.09.4A1.5,1.5,0,0,1,314.37,141.42Zm.66-.3h1.72a1,1,0,0,0-.9-.64A.84.84,0,0,0,315,141.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,143.76v-2.33h0v-1.21a.34.34,0,0,1,.66-.07,1.53,1.53,0,0,1,.83-.25,1.52,1.52,0,0,1,0,3,1.4,1.4,0,0,1-.82-.25v1.07a.34.34,0,0,1-.67,0Zm.67-2.33a.82.82,0,0,0,.24.61.74.74,0,0,0,.58.25.77.77,0,0,0,.57-.25.91.91,0,0,0,.24-.61,1,1,0,0,0-.24-.62.81.81,0,0,0-.57-.25.78.78,0,0,0-.58.25A.86.86,0,0,0,319,141.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,149.18a.33.33,0,0,1,.45,0,1.93,1.93,0,0,0,1.16.47,1.27,1.27,0,0,0,.76-.23.54.54,0,0,0,.26-.43.42.42,0,0,0,0-.2.55.55,0,0,0-.19-.18,2.32,2.32,0,0,0-.83-.29h0a3,3,0,0,1-.79-.24,1.23,1.23,0,0,1-.56-.47.88.88,0,0,1-.14-.5,1.13,1.13,0,0,1,.48-.89,1.8,1.8,0,0,1,1.06-.32,2.38,2.38,0,0,1,1.32.49.31.31,0,1,1-.34.52,1.75,1.75,0,0,0-1-.39,1.15,1.15,0,0,0-.68.21.47.47,0,0,0-.24.38.31.31,0,0,0,.05.17.6.6,0,0,0,.16.16,2.07,2.07,0,0,0,.76.27h0a3.78,3.78,0,0,1,.84.25,1.39,1.39,0,0,1,.61.51,1,1,0,0,1,.15.52,1.18,1.18,0,0,1-.52.94,1.92,1.92,0,0,1-1.13.35,2.68,2.68,0,0,1-1.56-.61A.34.34,0,0,1,305,149.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.46,146a.34.34,0,0,1,.34.34v3.59a.34.34,0,0,1-.67,0v-3.59A.34.34,0,0,1,309.46,146Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.66,148.72a1.51,1.51,0,0,1,1.49-1.52,1.44,1.44,0,0,1,1.46,1.41v.09a.3.3,0,0,1-.32.24h-1.93a.76.76,0,0,0,.2.4.94.94,0,0,0,.59.28,1,1,0,0,0,.63-.16.35.35,0,0,1,.46,0,.27.27,0,0,1,0,.39,1.56,1.56,0,0,1-1.09.4A1.51,1.51,0,0,1,310.66,148.72Zm.66-.3h1.73a1,1,0,0,0-.9-.64A.85.85,0,0,0,311.32,148.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.37,148.72a1.5,1.5,0,0,1,1.48-1.52,1.46,1.46,0,0,1,1.47,1.41v0a.15.15,0,0,1,0,.06.29.29,0,0,1-.31.24h-1.94a.78.78,0,0,0,.21.4.91.91,0,0,0,.58.28,1,1,0,0,0,.63-.16.35.35,0,0,1,.46,0,.27.27,0,0,1,0,.39,1.56,1.56,0,0,1-1.09.4A1.5,1.5,0,0,1,314.37,148.72Zm.66-.3h1.72a1,1,0,0,0-.9-.64A.84.84,0,0,0,315,148.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,151.06v-2.33h0v-1.21a.32.32,0,0,1,.33-.32.32.32,0,0,1,.33.25,1.53,1.53,0,0,1,.83-.25,1.52,1.52,0,0,1,0,3A1.4,1.4,0,0,1,319,150v1.07a.34.34,0,0,1-.67,0Zm.67-2.33a.82.82,0,0,0,.24.61.74.74,0,0,0,.58.25.77.77,0,0,0,.57-.25.91.91,0,0,0,.24-.61,1,1,0,0,0-.24-.62.81.81,0,0,0-.57-.25.78.78,0,0,0-.58.25A.86.86,0,0,0,319,148.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.07,169.66h-1v3.25a.34.34,0,1,1-.67,0v-3.25h-1a.34.34,0,0,1-.33-.34.34.34,0,0,1,.33-.34h2.6a.34.34,0,0,1,.34.34A.34.34,0,0,1,310.07,169.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76,169.44a.33.33,0,0,1-.33.33.33.33,0,0,1-.33-.33v-.13a.33.33,0,0,1,.33-.33.33.33,0,0,1,.33.33Zm0,1.1v2.38a.33.33,0,0,1-.33.33.33.33,0,0,1-.33-.33v-2.38a.33.33,0,0,1,.33-.33A.32.32,0,0,1,311.76,170.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35,171.46v1.46a.32.32,0,0,1-.32.33.34.34,0,0,1-.33-.33v-1.46a.62.62,0,0,0-1.24,0v1.44s0,0,0,0v0s0,0,0,0v0a.37.37,0,0,1-.31.2h-.06a.33.33,0,0,1-.26-.32v-1.44h0v-.94a.32.32,0,0,1,.32-.33.31.31,0,0,1,.29.18,1.35,1.35,0,0,1,.65-.18,1.31,1.31,0,0,0,1.92,0,1.27,1.27,0,0,1,1.26,1.28v1.44a.32.32,0,0,1-.32.33.33.33,0,0,1-.33-.33v-1.44a.62.62,0,0,0-.61-.63A.65.65,0,0,0,315.35,171.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.38,171.72a1.51,1.51,0,0,1,1.49-1.52,1.45,1.45,0,0,1,1.46,1.41v.09a.3.3,0,0,1-.32.24h-1.94a.78.78,0,0,0,.21.4.94.94,0,0,0,.59.28,1,1,0,0,0,.63-.15.34.34,0,0,1,.46,0,.28.28,0,0,1,0,.39,1.53,1.53,0,0,1-2.58-1.12Zm.66-.3h1.73a1,1,0,0,0-.9-.64A.86.86,0,0,0,319,171.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.14,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.68l-.13.08a.19.19,0,0,1-.1,0,.18.18,0,0,1-.16-.1.17.17,0,0,1,.06-.25l.42-.25h.24a0,0,0,0,0,0,0v0h0V171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.57,172.05a1.52,1.52,0,0,1,.24-.81.75.75,0,0,1,.63-.38.77.77,0,0,1,.63.38,1.51,1.51,0,0,1,.23.81,1.55,1.55,0,0,1-.23.82.79.79,0,0,1-.63.38.78.78,0,0,1-.63-.38A1.55,1.55,0,0,1,344.57,172.05Zm1.35,0a1.15,1.15,0,0,0-.16-.6.43.43,0,0,0-.32-.21.42.42,0,0,0-.32.21,1.07,1.07,0,0,0-.17.6,1.1,1.1,0,0,0,.17.61.42.42,0,0,0,.32.21.43.43,0,0,0,.32-.21A1.19,1.19,0,0,0,345.92,172.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,172.32h-.42v.74a.19.19,0,0,1-.38,0v-2a.19.19,0,0,1,.19-.19H349a.73.73,0,1,1,0,1.46Zm-.42-.38H349a.35.35,0,0,0,.35-.35.35.35,0,0,0-.35-.35h-.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.19,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.43l-.49.68a.18.18,0,0,1-.15.07h0a.2.2,0,0,1-.16-.07l-.48-.68v1.43a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-2a.19.19,0,0,1,.19-.19h0a.21.21,0,0,1,.15.08l.67.94.68-.94a.19.19,0,0,1,.15-.08h0A.2.2,0,0,1,352.19,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.68l-.13.08a.19.19,0,0,1-.1,0,.19.19,0,0,1-.1-.35l.42-.25H365a0,0,0,0,0,0,0v0h0V171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.14,171.05v2a.19.19,0,0,1-.38,0v-1.68l-.13.08a.19.19,0,0,1-.1,0,.19.19,0,0,1-.1-.35l.42-.25h.24a0,0,0,0,0,0,0v0h0v0s0,0,0,0v0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.53,172.32h-.42v.74a.19.19,0,0,1-.38,0v-2a.19.19,0,0,1,.19-.19h.61a.73.73,0,1,1,0,1.46Zm-.42-.38h.42a.34.34,0,0,0,.35-.35.35.35,0,0,0-.35-.35h-.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.43l-.49.68a.18.18,0,0,1-.15.07h0a.2.2,0,0,1-.16-.07l-.48-.68v1.43a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-2a.19.19,0,0,1,.19-.19h0a.21.21,0,0,1,.15.08l.67.94.68-.94a.19.19,0,0,1,.15-.08h0A.2.2,0,0,1,371.77,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.68,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.68l-.14.08a.17.17,0,0,1-.25-.07.17.17,0,0,1,.06-.25l.42-.25h.19a0,0,0,0,1,0,0h0l0,0h0V171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,173.06a.19.19,0,0,1-.19.19h-1.21a.19.19,0,0,1-.14-.07.19.19,0,0,1,0-.26l1-.91a.43.43,0,0,0,.14-.33.48.48,0,0,0-.11-.3.47.47,0,0,0-.33-.14.46.46,0,0,0-.29.11l-.11.1a.19.19,0,0,1-.26,0,.19.19,0,0,1,0-.27l.1-.1a.84.84,0,0,1,.55-.21.86.86,0,0,1,.61.27.84.84,0,0,1,.21.55.82.82,0,0,1-.27.61l-.64.58h.72A.18.18,0,0,1,386.65,173.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49,172.68h-.82l-.17.45a.2.2,0,0,1-.18.12l-.06,0a.19.19,0,0,1-.12-.24l.76-2a.19.19,0,0,1,.36,0l.75,2a.19.19,0,0,1-.11.24l-.07,0a.19.19,0,0,1-.17-.12Zm-.14-.37-.27-.73-.28.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.43l-.49.68a.18.18,0,0,1-.15.07h0a.2.2,0,0,1-.16-.07l-.48-.68v1.43a.19.19,0,0,1-.38,0v-2a.2.2,0,0,1,.19-.19h0a.21.21,0,0,1,.15.08l.67.94.68-.94a.19.19,0,0,1,.15-.08h0A.2.2,0,0,1,392.53,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.9,171.05v2a.19.19,0,0,1-.38,0v-1.68l-.13.08a.19.19,0,0,1-.1,0,.19.19,0,0,1-.1-.35l.42-.25h.24a0,0,0,0,0,0,0v0h0V171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.71,172.68h-.83l-.17.45a.19.19,0,0,1-.17.12l-.07,0a.18.18,0,0,1-.11-.24l.75-2a.18.18,0,0,1,.18-.12.17.17,0,0,1,.18.12l.75,2a.18.18,0,0,1-.11.24l-.06,0a.2.2,0,0,1-.18-.12Zm-.14-.37-.28-.73-.27.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,171.05v2a.19.19,0,0,1-.38,0v-1.43l-.48.68a.2.2,0,0,1-.16.07h0a.18.18,0,0,1-.15-.07l-.49-.68v1.43a.19.19,0,0,1-.19.19.2.2,0,0,1-.19-.19v-2a.2.2,0,0,1,.19-.19h0a.18.18,0,0,1,.15.08l.68.94.68-.94a.18.18,0,0,1,.15-.08h0A.2.2,0,0,1,411.74,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.52,173.06a.19.19,0,0,1-.19.19h-1.21a.19.19,0,0,1-.14-.07.18.18,0,0,1,0-.26l1-.91a.47.47,0,0,0,.14-.33.48.48,0,0,0-.11-.3.47.47,0,0,0-.33-.14.48.48,0,0,0-.3.11l-.1.1a.2.2,0,0,1-.27,0,.19.19,0,0,1,0-.27l.1-.1a.84.84,0,0,1,.55-.21.86.86,0,0,1,.61.27.84.84,0,0,1,.21.55.86.86,0,0,1-.27.61l-.65.58h.73A.18.18,0,0,1,426.52,173.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.36,172.68h-.83l-.16.45a.21.21,0,0,1-.18.12l-.07,0A.19.19,0,0,1,428,173l.75-2a.19.19,0,0,1,.19-.12.19.19,0,0,1,.18.12l.75,2a.19.19,0,0,1-.11.24l-.07,0a.18.18,0,0,1-.17-.12Zm-.14-.37-.27-.73-.28.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.43l-.49.68a.18.18,0,0,1-.15.07h0a.2.2,0,0,1-.16-.07l-.48-.68v1.43a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-2a.19.19,0,0,1,.19-.19h0a.21.21,0,0,1,.15.08l.67.94.68-.94a.19.19,0,0,1,.15-.08h0A.2.2,0,0,1,432.4,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.45,171.8a.84.84,0,1,1-1.19,1.19.18.18,0,0,1,0-.27.2.2,0,0,1,.27,0,.46.46,0,0,0,.33.13.45.45,0,0,0,.32-.13.47.47,0,0,0,.14-.33.47.47,0,0,0-.14-.32.44.44,0,0,0-.32-.13.17.17,0,0,1-.14-.07h0a.19.19,0,0,1,0-.27l.35-.36h-.56a.19.19,0,1,1,0-.38h1a.18.18,0,0,1,.19.19.24.24,0,0,1,0,.09.1.1,0,0,1,0,.05l-.42.44A.76.76,0,0,1,446.45,171.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.61,172.68h-.82l-.17.45a.2.2,0,0,1-.18.12l-.06,0a.18.18,0,0,1-.11-.24l.75-2a.2.2,0,0,1,.36,0l.75,2a.18.18,0,0,1-.11.24l-.06,0a.2.2,0,0,1-.18-.12Zm-.14-.37-.27-.73-.28.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.65,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.43l-.49.68a.17.17,0,0,1-.15.07h0a.17.17,0,0,1-.15-.07l-.49-.68v1.43a.19.19,0,0,1-.38,0v-2a.2.2,0,0,1,.19-.19h0a.19.19,0,0,1,.15.08l.68.94.67-.94a.21.21,0,0,1,.16-.08h0A.2.2,0,0,1,452.65,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.11,172.61a.18.18,0,0,1-.19.19h0v.26a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-.26h-1.07a.19.19,0,0,1-.12,0,.19.19,0,0,1,0-.26l1.26-1.57h.29v0s0,0,0,0h0v0h0v0h0v1.38h0A.18.18,0,0,1,467.11,172.61Zm-.6-1-.68.85h.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.92,172.68h-.82l-.17.45a.2.2,0,0,1-.18.12l-.06,0a.18.18,0,0,1-.11-.24l.75-2a.18.18,0,0,1,.18-.12.17.17,0,0,1,.18.12l.75,2a.18.18,0,0,1-.11.24l-.06,0a.2.2,0,0,1-.18-.12Zm-.13-.37-.28-.73-.28.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,171.05v2a.19.19,0,0,1-.38,0v-1.43l-.49.68a.17.17,0,0,1-.15.07h0a.17.17,0,0,1-.15-.07l-.49-.68v1.43a.19.19,0,0,1-.19.19.2.2,0,0,1-.19-.19v-2a.2.2,0,0,1,.19-.19h0a.19.19,0,0,1,.15.08l.68.94.67-.94a.21.21,0,0,1,.16-.08h0A.2.2,0,0,1,473,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.87,171.8a.85.85,0,0,1-.6,1.45h0a.85.85,0,0,1-.59-.25.19.19,0,0,1,0-.28.2.2,0,0,1,.27,0,.43.43,0,0,0,.33.14.4.4,0,0,0,.32-.14.45.45,0,0,0,0-.65.42.42,0,0,0-.32-.13.48.48,0,0,0-.33.13.18.18,0,0,1-.27,0l0,0h0s0,0,0,0v0h0a.06.06,0,0,1,0-.06l.1-.88a.22.22,0,0,1,.08-.13h0l.09,0h1a.2.2,0,1,1,0,.39h-.84l0,.33.23,0A.87.87,0,0,1,486.87,171.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,172.68h-.82l-.17.45a.2.2,0,0,1-.18.12l-.06,0a.18.18,0,0,1-.11-.24l.75-2a.19.19,0,0,1,.36,0l.75,2a.18.18,0,0,1-.11.24l-.07,0a.19.19,0,0,1-.17-.12Zm-.14-.37-.27-.73-.28.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.08,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.43l-.49.68a.18.18,0,0,1-.15.07h0a.17.17,0,0,1-.15-.07l-.49-.68v1.43a.19.19,0,0,1-.38,0v-2a.2.2,0,0,1,.19-.19h0a.21.21,0,0,1,.15.08l.68.94.67-.94a.21.21,0,0,1,.16-.08h0A.2.2,0,0,1,493.08,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.42,172.42a.83.83,0,0,1-.83.83.84.84,0,0,1-.82-.74h0c0-.06,0-.13,0-.19a2.1,2.1,0,0,1,.12-.7,1.21,1.21,0,0,1,.44-.58.91.91,0,0,1,.51-.16.18.18,0,0,1,.2.18.19.19,0,0,1-.18.19.75.75,0,0,0-.32.1.73.73,0,0,0-.22.24l0,.09a.71.71,0,0,1,.32-.07A.83.83,0,0,1,507.42,172.42Zm-.38,0a.45.45,0,1,0-.89,0,.45.45,0,1,0,.89,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.33,172.68h-.83l-.17.45a.19.19,0,0,1-.17.12l-.07,0A.19.19,0,0,1,509,173l.75-2a.18.18,0,0,1,.18-.12.17.17,0,0,1,.18.12l.75,2a.18.18,0,0,1-.11.24l-.06,0a.2.2,0,0,1-.18-.12Zm-.14-.37-.28-.73-.27.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.36,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.18-.19v-1.43l-.49.68a.2.2,0,0,1-.16.07h0a.19.19,0,0,1-.16-.07l-.49-.68v1.43a.19.19,0,0,1-.19.19.2.2,0,0,1-.19-.19v-2a.2.2,0,0,1,.19-.19h0a.18.18,0,0,1,.15.08l.68.94.68-.94a.18.18,0,0,1,.15-.08h0A.2.2,0,0,1,513.36,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.6,171.12l-.85,2a.17.17,0,0,1-.17.12l-.07,0a.18.18,0,0,1-.1-.24l.73-1.75h-.88a.19.19,0,0,1-.18-.19.18.18,0,0,1,.18-.19h1.21l.07,0h0v0h0V171h0v.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.45,172.68h-.82l-.17.45a.2.2,0,0,1-.18.12l-.06,0a.19.19,0,0,1-.12-.24l.76-2a.2.2,0,0,1,.36,0l.75,2a.19.19,0,0,1-.11.24l-.07,0a.19.19,0,0,1-.17-.12Zm-.14-.37-.27-.73-.28.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.49,171.05v2a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-1.43l-.49.68a.18.18,0,0,1-.15.07h0a.2.2,0,0,1-.16-.07l-.48-.68v1.43a.2.2,0,0,1-.19.19.19.19,0,0,1-.19-.19v-2a.19.19,0,0,1,.19-.19h0a.21.21,0,0,1,.15.08l.67.94.68-.94a.19.19,0,0,1,.15-.08h0A.2.2,0,0,1,533.49,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.82,172.44a.81.81,0,0,1-.81.81.82.82,0,0,1-.82-.81.8.8,0,0,1,.37-.68.56.56,0,0,1-.12-.34.57.57,0,0,1,.57-.56.57.57,0,0,1,.56.56.55.55,0,0,1-.11.34A.82.82,0,0,1,547.82,172.44Zm-.37,0A.45.45,0,0,0,547,172a.45.45,0,0,0-.45.45.44.44,0,0,0,.45.43A.44.44,0,0,0,547.45,172.44Zm-.63-1a.19.19,0,0,0,.19.2.2.2,0,0,0,.19-.2.2.2,0,0,0-.19-.19A.19.19,0,0,0,546.82,171.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.75,172.68h-.83l-.17.45a.19.19,0,0,1-.17.12l-.07,0a.18.18,0,0,1-.11-.24l.75-2a.18.18,0,0,1,.18-.12.17.17,0,0,1,.18.12l.75,2a.18.18,0,0,1-.11.24l-.06,0a.2.2,0,0,1-.18-.12Zm-.14-.37-.28-.73-.28.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.78,171.05v2a.19.19,0,0,1-.38,0v-1.43l-.49.68a.17.17,0,0,1-.15.07h0a.17.17,0,0,1-.15-.07l-.49-.68v1.43a.19.19,0,0,1-.19.19.2.2,0,0,1-.19-.19v-2a.2.2,0,0,1,.19-.19h0a.19.19,0,0,1,.15.08l.68.94.67-.94a.21.21,0,0,1,.16-.08h0A.2.2,0,0,1,553.78,171.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.69,184.41a.33.33,0,0,1,.45,0,2,2,0,0,0,1.16.47,1.32,1.32,0,0,0,.76-.22.57.57,0,0,0,.26-.44.33.33,0,0,0-.05-.2.61.61,0,0,0-.18-.18,2.46,2.46,0,0,0-.84-.29h0a3.16,3.16,0,0,1-.79-.23,1.25,1.25,0,0,1-.56-.48.92.92,0,0,1-.14-.5,1.14,1.14,0,0,1,.49-.89,1.81,1.81,0,0,1,1.05-.32,2.41,2.41,0,0,1,1.33.49.31.31,0,0,1,.08.43.3.3,0,0,1-.43.09,1.75,1.75,0,0,0-1-.39,1.15,1.15,0,0,0-.68.21.46.46,0,0,0-.23.38.29.29,0,0,0,0,.17.48.48,0,0,0,.16.16,2.07,2.07,0,0,0,.76.27h0a3.94,3.94,0,0,1,.84.25,1.5,1.5,0,0,1,.6.51.93.93,0,0,1,.15.52,1.18,1.18,0,0,1-.52.94,1.92,1.92,0,0,1-1.13.35,2.68,2.68,0,0,1-1.56-.61A.34.34,0,0,1,304.69,184.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.36,183.7v1.45a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32V183.7a.63.63,0,0,0-.64-.62.61.61,0,0,0-.6.62v1.45a.07.07,0,0,1,0,.06.32.32,0,0,1-.32.26.32.32,0,0,1-.32-.32v-2.4a.32.32,0,0,1,.32-.32.33.33,0,0,1,.3.19,1.17,1.17,0,0,1,.64-.19A1.28,1.28,0,0,1,311.36,183.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.83,185a1.5,1.5,0,0,1-.42-1.07,1.55,1.55,0,0,1,.42-1.07,1.42,1.42,0,0,1,1-.46,1.36,1.36,0,0,1,1,.46,1.56,1.56,0,0,1,.43,1.07,1.5,1.5,0,0,1-.43,1.07,1.33,1.33,0,0,1-1,.46A1.38,1.38,0,0,1,312.83,185Zm.24-1.07a1,1,0,0,0,.22.64.8.8,0,0,0,.58.23.77.77,0,0,0,.56-.23.89.89,0,0,0,.24-.64.87.87,0,0,0-.24-.63.82.82,0,0,0-.56-.24.85.85,0,0,0-.58.24A1,1,0,0,0,313.07,184Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.1,182.75a.33.33,0,0,1-.32.33.6.6,0,0,0-.37.11,1.11,1.11,0,0,0-.28.29,2.09,2.09,0,0,0-.25.52v1.15a.32.32,0,0,1-.33.32.32.32,0,0,1-.32-.32v-2.4a.31.31,0,0,1,.32-.31.32.32,0,0,1,.33.31v.05l.13-.13a1.35,1.35,0,0,1,.77-.23A.31.31,0,0,1,318.1,182.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.38,184a1.51,1.51,0,0,1,1.49-1.52,1.45,1.45,0,0,1,1.46,1.41v.09a.3.3,0,0,1-.32.24h-1.94a.78.78,0,0,0,.21.4.94.94,0,0,0,.59.28,1,1,0,0,0,.63-.15.34.34,0,0,1,.46,0,.28.28,0,0,1,0,.39,1.54,1.54,0,0,1-2.58-1.12Zm.66-.3h1.73a1,1,0,0,0-.9-.64A.85.85,0,0,0,319,183.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,79l.25,43.26.09,43.26-.34-.33,58.53-.13c19.52-.08,39,0,58.54.05l58.53.13c19.51,0,39,.18,58.53.28-19.51.11-39,.29-58.53.29L445.1,166c-19.51,0-39,.13-58.54.05L328,165.9h-.34v-.34l.09-43.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.94,165.56c-.11-14.2-.08-28.4-.13-42.6s0-28.4.13-42.6c.11,14.2.08,28.4.12,42.6S348,151.36,347.94,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.16,165.56c-.11-14.2-.08-28.4-.13-42.6s0-28.4.13-42.6c.1,14.2.08,28.4.12,42.6S368.26,151.36,368.16,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.38,165.56c-.11-14.2-.08-28.4-.13-42.6s0-28.4.13-42.6c.1,14.2.08,28.4.12,42.6S388.48,151.36,388.38,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.6,165.56c-.11-14.2-.08-28.4-.13-42.6s0-28.4.13-42.6c.1,14.2.08,28.4.12,42.6S408.7,151.36,408.6,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81,165.56c-.1-14.2-.08-28.4-.12-42.6s0-28.4.12-42.6c.11,14.2.09,28.4.13,42.6S428.92,151.36,428.81,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,165.56c-.1-14.2-.08-28.4-.12-42.6s0-28.4.12-42.6c.11,14.2.08,28.4.13,42.6S449.14,151.36,449,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.25,165.56c-.1-14.2-.08-28.4-.12-42.6s0-28.4.12-42.6c.11,14.2.08,28.4.13,42.6S469.36,151.36,469.25,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.47,165.56c-.11-14.2-.08-28.4-.12-42.6s0-28.4.12-42.6c.11,14.2.08,28.4.13,42.6S489.58,151.36,489.47,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.69,165.56c-.11-14.2-.08-28.4-.12-42.6s0-28.4.12-42.6c.11,14.2.08,28.4.13,42.6S509.8,151.36,509.69,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.91,165.56c-.11-14.2-.08-28.4-.12-42.6s0-28.4.12-42.6c.11,14.2.08,28.4.13,42.6S530,151.36,529.91,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.13,165.56c-.11-14.2-.08-28.4-.12-42.6s0-28.4.12-42.6c.11,14.2.08,28.4.12,42.6S550.24,151.36,550.13,165.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.13,183.82v.32c-12.38,0-27.89.05-31.14.26-21.62,1.37-21.24,4.3-29,4.3-6,0-17.47-4.4-27.75-4.4s-13.13,1.52-20.16,1.52c-6.81,0-8.68-1.42-23.32-1.51H391.21c-16.1,0-16.73,2.85-21.75,2.85-6.21,0-7-3-18.4-3H328v-.32h23c11.36,0,12.64-3,18.12-3s5.93,2.85,22,2.85h27.62c14.62-.1,16.49-1.51,23.29-1.51,7,0,9.88,1.52,20.16,1.52s21.79-4.4,27.75-4.4c7.72,0,7.34,2.93,29,4.3C522.24,183.77,537.75,183.82,550.13,183.82Z",
    style: {
      fill: "#FFC727",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,85.14c5.61,0,8.82,4.9,10.74,5.85s4,11,4.84,13.52,2.06,15.09,2.44,16.55.56,10,1.89,10,5.57,2.74,7.18,4.35,5.48,8.22,7.46,8.22,3.5,9.54,5.58,9.54,5.67-3.59,7.08-4.91,6.14-1.14,7.18-2.37,3.88-9.07,6-9.63,4.53,2.26,6.61,2,5.67-1,7.56-1,4.06,7.65,6.05,8,6-9.07,8.5-11,3.39-.19,5.9-2.55,3.36-25.54,5.81-26.47,7-1.68,8.6-2.72,7.47-5.86,11.62-5.86,4.63,11.15,6.15,12.09,4.34,4.6,5.66,7.26,2.87,14.85,4.41,16.08,2.59,5.57,4,7,5.86-.28,7.84,1.23,4.54,9,6.15,10.11,3.87,4.65,6.23,4.65,9.92-9.75,13.23-10.79,5.57-8.51,7-9.83,8.32.28,10.77-.47,6.52-15.78,9.45-15.78,6.24,2.55,9.73,2.55S545.88,95,550.13,95v70.53H328Z",
    style: {
      fill: "#FFC727",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.47,155.55c-1.82,0-3.44-1.69-4.87-3.18a14,14,0,0,0-1.65-1.56c-.87-.62-1.84-2.57-2.95-4.83s-2.27-4.58-3.21-5.29-2.41-.61-3.9-.55-3.14.12-4-.73A12.34,12.34,0,0,1,467,136a10.75,10.75,0,0,0-2-3.49c-.94-.75-1.67-4-2.75-9.15a45.28,45.28,0,0,0-1.79-7.1c-1.3-2.6-4.07-6.17-5.49-7-.68-.43-1-1.75-1.66-4.24-.81-3.28-1.93-7.78-4.22-7.78-3.3,0-8,3.36-10.2,5-.48.35-.87.63-1.15.81a20.69,20.69,0,0,1-5.06,1.71c-1.3.34-2.66.69-3.63,1.06s-2,7.73-2.61,12.59c-1,7.77-1.76,12.58-3,13.77a5.14,5.14,0,0,1-3.41,1.61,4.37,4.37,0,0,0-2.53,1c-1,.76-2.36,3-3.68,5.18-2.33,3.81-3.82,6.14-5.22,5.87-1.21-.23-2.21-2.13-3.36-4.33-.77-1.47-1.94-3.69-2.59-3.69a38.31,38.31,0,0,0-5.16.66c-.86.15-1.67.29-2.33.38a6.15,6.15,0,0,1-3.45-1.07c-1.14-.61-2.21-1.18-3.1-.93-1.17.32-3,4.15-4.09,6.45a19.69,19.69,0,0,1-1.61,3c-.64.75-2.06,1-3.72,1.31-1.36.25-2.9.53-3.51,1.09l-.42.4c-1.71,1.62-4.91,4.65-7,4.65-1.4,0-2.29-2.4-3.33-5.18-.6-1.63-1.61-4.36-2.25-4.36-1.49,0-3.33-2.38-5.77-5.73a26.89,26.89,0,0,0-2.05-2.64c-1.68-1.69-5.77-4.2-6.82-4.2s-1.58-2.24-2.06-7.6a26.08,26.08,0,0,0-.32-2.74c-.15-.58-.4-2.65-.72-5.27-.5-4.1-1.18-9.7-1.71-11.25-.22-.67-.53-1.83-.88-3.18-.86-3.3-2.47-9.44-3.7-10a10.61,10.61,0,0,1-2.08-1.63c-1.94-1.76-4.61-4.17-8.44-4.17v-1c4.22,0,7.16,2.66,9.11,4.43A10.93,10.93,0,0,0,339,90.54c1.52.75,2.81,5.29,4.23,10.7.34,1.32.64,2.47.86,3.11.56,1.64,1.22,7.08,1.75,11.45.31,2.48.57,4.62.7,5.14a24.32,24.32,0,0,1,.34,2.9c.18,2,.56,6.27,1.16,6.71h0c1.47,0,5.79,2.83,7.43,4.47a27.14,27.14,0,0,1,2.15,2.76c1.45,2,3.87,5.32,5,5.32,1.27,0,2,1.9,3.19,5,.63,1.69,1.68,4.53,2.39,4.53,1.69,0,4.93-3.07,6.31-4.38l.43-.4c.82-.76,2.44-1.06,4-1.35,1.28-.23,2.73-.49,3.13-1a19.68,19.68,0,0,0,1.48-2.81c1.77-3.71,3.24-6.58,4.72-7,1.28-.34,2.58.35,3.84,1a5.3,5.3,0,0,0,2.84,1c.65-.09,1.46-.23,2.31-.37a38.13,38.13,0,0,1,5.32-.68c1.26,0,2.28,2,3.47,4.23.86,1.63,1.93,3.67,2.67,3.81s2.91-3.34,4.18-5.42c1.43-2.35,2.78-4.57,3.92-5.44a5.34,5.34,0,0,1,3-1.18,4.22,4.22,0,0,0,2.85-1.34c1.1-1,2-7.49,2.73-13.19,1.2-8.91,1.87-12.86,3.25-13.39,1-.38,2.4-.74,3.73-1.09a21.38,21.38,0,0,0,4.77-1.58c.26-.17.64-.44,1.1-.78,2.51-1.8,7.17-5.16,10.79-5.16,3.07,0,4.25,4.73,5.2,8.54.35,1.43.84,3.4,1.21,3.63,1.57,1,4.47,4.67,5.85,7.46a42.15,42.15,0,0,1,1.88,7.33c.7,3.38,1.67,8,2.4,8.58.91.72,1.62,2.32,2.3,3.86a12.26,12.26,0,0,0,1.74,3.17c.54.54,1.91.48,3.25.43,1.66-.06,3.38-.13,4.54.75s2.33,3.3,3.49,5.65c.92,1.87,2,4,2.63,4.45a14.1,14.1,0,0,1,1.8,1.68c1.29,1.35,2.76,2.88,4.15,2.88,1,0,3.77-2.74,6-5,2.62-2.59,5.33-5.27,7.08-5.82,2-.62,3.68-4.05,4.93-6.55a13.17,13.17,0,0,1,1.87-3.16c.94-.88,3.33-.73,6.09-.54a17.35,17.35,0,0,0,4.87-.05c.92-.28,2.54-4,3.84-7,2.4-5.49,4-8.83,5.76-8.83a13.21,13.21,0,0,1,4.62,1.23,14.47,14.47,0,0,0,5.11,1.32c1.28,0,3-6.66,4.24-11.53,2.26-8.82,3.81-14.17,6.25-14.17v1c-1.84,0-3.83,7.76-5.29,13.42-2,7.61-3.25,12.28-5.2,12.28a15.28,15.28,0,0,1-5.47-1.39,12.46,12.46,0,0,0-4.26-1.16c-1.25,0-3.33,4.76-4.85,8.23-1.92,4.41-3.17,7.13-4.45,7.53a17.57,17.57,0,0,1-5.24.09c-2.1-.14-4.71-.32-5.34.27a13.47,13.47,0,0,0-1.65,2.87c-1.41,2.82-3.15,6.32-5.53,7.06-1.52.48-4.26,3.19-6.68,5.58C492.89,153.56,490.8,155.55,489.47,155.55Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.96 185.05 293.83 131.69 293.96 78.33 294.08 131.69 293.96 185.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,133.08A37.27,37.27,0,1,1,256.9,97.37a28.3,28.3,0,1,0,22.66,35.71Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,115.32a5.11,5.11,0,1,1-7.93-4.25,3.44,3.44,0,0,1-.7-2.12,3.53,3.53,0,0,1,7.05,0,3.45,3.45,0,0,1-.71,2.12A5.13,5.13,0,0,1,250.05,115.32Zm-2.33,0a2.78,2.78,0,0,0-2.76-2.78,2.77,2.77,0,1,0,0,5.54A2.77,2.77,0,0,0,247.72,115.32Zm-4-6.37a1.2,1.2,0,1,0,2.39,0,1.2,1.2,0,0,0-2.39,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,111.35a5.21,5.21,0,0,1,1.56,3.76,5.31,5.31,0,0,1-1.56,3.74,5.22,5.22,0,0,1-3.73,1.55h-.05a5.18,5.18,0,0,1-3.71-1.55,1.16,1.16,0,0,1,0-1.71,1.2,1.2,0,0,1,1.7,0,2.88,2.88,0,0,0,4.09,0,2.94,2.94,0,0,0,.85-2,2.8,2.8,0,0,0-.85-2,2.77,2.77,0,0,0-2-.84,2.86,2.86,0,0,0-2.06.84,1.2,1.2,0,0,1-1.7,0c-.09-.09-.15-.2-.24-.28s0-.07,0-.07a.15.15,0,0,0,0-.1c0-.07,0-.11,0-.15s0,0,0,0a1.15,1.15,0,0,1,0-.37l.65-5.53a1.3,1.3,0,0,1,.53-.86l.08,0,.07,0a1.12,1.12,0,0,1,.55-.13h6.31a1.21,1.21,0,1,1,0,2.42h-5.26l-.26,2.11a5.48,5.48,0,0,1,1.44-.19A5.19,5.19,0,0,1,261.39,111.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.61,129.8a.48.48,0,0,1,.67-.06,3,3,0,0,0,1.75.7,2,2,0,0,0,1.14-.34.83.83,0,0,0,.39-.66.47.47,0,0,0-.08-.29.86.86,0,0,0-.27-.27,3.79,3.79,0,0,0-1.26-.44h0a5.09,5.09,0,0,1-1.18-.35,2.06,2.06,0,0,1-.85-.72,1.37,1.37,0,0,1-.21-.75,1.68,1.68,0,0,1,.73-1.33,2.73,2.73,0,0,1,1.59-.49,3.56,3.56,0,0,1,2,.73.47.47,0,0,1,.13.65.46.46,0,0,1-.65.14,2.66,2.66,0,0,0-1.47-.59,1.73,1.73,0,0,0-1,.32.71.71,0,0,0-.35.57.42.42,0,0,0,.07.26.82.82,0,0,0,.25.24,3.17,3.17,0,0,0,1.14.4h0a5.48,5.48,0,0,1,1.26.38,2.23,2.23,0,0,1,.92.76,1.57,1.57,0,0,1,.22.78,1.76,1.76,0,0,1-.79,1.42,2.85,2.85,0,0,1-1.69.52,4,4,0,0,1-2.35-.91A.49.49,0,0,1,239.61,129.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.38,125a.51.51,0,0,1,.52.51v5.4a.51.51,0,0,1-1,0v-5.4A.51.51,0,0,1,246.38,125Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.19,129.1a2.26,2.26,0,0,1,2.23-2.28,2.18,2.18,0,0,1,2.21,2.12V129a.25.25,0,0,1,0,.08.44.44,0,0,1-.48.36h-2.91a1.32,1.32,0,0,0,.31.61,1.45,1.45,0,0,0,.88.41,1.43,1.43,0,0,0,1-.23.53.53,0,0,1,.69,0,.42.42,0,0,1,0,.6,2.32,2.32,0,0,1-1.64.6A2.27,2.27,0,0,1,248.19,129.1Zm1-.44h2.59a1.49,1.49,0,0,0-1.36-1A1.25,1.25,0,0,0,249.19,128.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,129.1a2.26,2.26,0,0,1,2.23-2.28,2.19,2.19,0,0,1,2.21,2.12V129a.25.25,0,0,1,0,.08.44.44,0,0,1-.48.36h-2.91a1.23,1.23,0,0,0,.31.61,1.42,1.42,0,0,0,.88.41,1.44,1.44,0,0,0,.95-.23.53.53,0,0,1,.69,0,.42.42,0,0,1,0,.6,2.32,2.32,0,0,1-1.64.6A2.26,2.26,0,0,1,253.77,129.1Zm1-.44h2.59a1.47,1.47,0,0,0-1.35-1A1.28,1.28,0,0,0,254.76,128.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.66,132.62v-3.5h0V127.3a.49.49,0,0,1,.49-.48.5.5,0,0,1,.5.37,2.33,2.33,0,0,1,1.25-.37,2.27,2.27,0,0,1,2.21,2.29,2.24,2.24,0,0,1-2.21,2.27,2.11,2.11,0,0,1-1.23-.37v1.61a.51.51,0,0,1-.52.49A.5.5,0,0,1,259.66,132.62Zm1-3.51a1.22,1.22,0,0,0,.36.92,1.1,1.1,0,0,0,.87.38,1.16,1.16,0,0,0,.86-.38,1.34,1.34,0,0,0,.35-.92,1.42,1.42,0,0,0-.35-.92,1.19,1.19,0,0,0-.86-.38,1.14,1.14,0,0,0-.87.38A1.28,1.28,0,0,0,260.67,129.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67,140.79a.48.48,0,0,1,.67-.07,3,3,0,0,0,1.74.71,2,2,0,0,0,1.15-.34.83.83,0,0,0,.39-.66.47.47,0,0,0-.08-.29,1,1,0,0,0-.27-.28,3.81,3.81,0,0,0-1.26-.43h0a5.09,5.09,0,0,1-1.18-.35,2,2,0,0,1-.85-.72,1.37,1.37,0,0,1-.21-.75,1.68,1.68,0,0,1,.73-1.33,2.66,2.66,0,0,1,1.59-.49,3.56,3.56,0,0,1,2,.73.47.47,0,0,1,.13.65.46.46,0,0,1-.65.14,2.69,2.69,0,0,0-1.47-.59,1.71,1.71,0,0,0-1,.32.71.71,0,0,0-.35.57.44.44,0,0,0,.07.26,1.07,1.07,0,0,0,.24.24,3.23,3.23,0,0,0,1.15.4h0a5.64,5.64,0,0,1,1.26.38,2.16,2.16,0,0,1,.92.76,1.57,1.57,0,0,1,.22.78,1.76,1.76,0,0,1-.79,1.42,2.88,2.88,0,0,1-1.7.52,4,4,0,0,1-2.34-.91A.49.49,0,0,1,239.67,140.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,140.1a2.33,2.33,0,0,1,2.32-2.3,2.46,2.46,0,0,1,1.46.51.51.51,0,0,1,.1.68.5.5,0,0,1-.69.09,1.43,1.43,0,0,0-.87-.3,1.36,1.36,0,0,0-1.35,1.32,1.34,1.34,0,0,0,1.35,1.31,1.51,1.51,0,0,0,.87-.29.5.5,0,0,1,.69.1.52.52,0,0,1-.1.68,2.57,2.57,0,0,1-1.46.48A2.31,2.31,0,0,1,245.56,140.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,141.71a2.25,2.25,0,0,1-.63-1.61,2.33,2.33,0,0,1,.63-1.6,2.13,2.13,0,0,1,1.57-.7,2,2,0,0,1,1.53.7,2.3,2.3,0,0,1,.64,1.6,2.22,2.22,0,0,1-.64,1.61,2,2,0,0,1-1.53.7A2.13,2.13,0,0,1,251.39,141.71Zm.36-1.61a1.46,1.46,0,0,0,.33,1,1.26,1.26,0,0,0,.88.34,1.22,1.22,0,0,0,.85-.34,1.49,1.49,0,0,0,0-1.92,1.33,1.33,0,0,0-.85-.35,1.36,1.36,0,0,0-.88.35A1.46,1.46,0,0,0,251.75,140.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.33,138.29a.48.48,0,0,1-.49.48.89.89,0,0,0-.55.18,1.36,1.36,0,0,0-.42.44,2.54,2.54,0,0,0-.37.77v1.74a.5.5,0,0,1-.51.48.49.49,0,0,1-.48-.48v-3.61a.48.48,0,0,1,.48-.48.49.49,0,0,1,.51.48v.06a1.09,1.09,0,0,1,.19-.18,2,2,0,0,1,1.15-.36A.48.48,0,0,1,259.33,138.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.75,140.09A2.27,2.27,0,0,1,262,137.8a2.19,2.19,0,0,1,2.21,2.13v0a.28.28,0,0,1,0,.09.44.44,0,0,1-.48.36h-2.91a1.32,1.32,0,0,0,.31.61,1.45,1.45,0,0,0,.88.41,1.53,1.53,0,0,0,1-.23.52.52,0,0,1,.68,0,.42.42,0,0,1,0,.6,2.32,2.32,0,0,1-1.64.6A2.27,2.27,0,0,1,259.75,140.09Zm1-.45h2.59a1.52,1.52,0,0,0-1.36-1A1.29,1.29,0,0,0,260.75,139.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.6 308.7 149.6 308.7 149.6 131.19 186.45 131.19 186.45 132.19 150.6 132.19 150.6 308.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.1,
    cy: 308.61,
    r: 1.88,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,133.57a1.88,1.88,0,1,0-1.88-1.88A1.88,1.88,0,0,0,186.36,133.57Z",
    style: {
      fill: "#263238"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEarlyNight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/early-night.cc85a155ef9eb464cad0b8bcc19b4179.svg";